<template>
    <div>
        <Keypress
            key-event="keyup"

            @success="checkKey"
        />
        <Keypress key-event="keyup" :multiple-keys="multiple" @success="checkKeyWithAlt"/>
        <div v-if="loading_form">
            <form autocomplete="off"
                  class="row no-gutters"
                  @submit.prevent="submit"
                  >
                <div class="col-xl-12 col-md-12 col-12">
                    <div class="row card-header no-gutters align-items-start"
                         style="background-color: #FFFFFF !important;">
                        <div class="col-xl-2 col-md-2 col-12">
                            <logo :path_logo="(company.logo != null) ? `/storage/uploads/logos/${company.logo}` : ''"
                                  :position_class="'text-left'"
                                  url="/"></logo>
                        </div>
                        <div class="col-xl-6 col-md-6 col-12 pl-2 align-self-center">
                            <address class="mb-0"
                                     style="line-height: initial;">
                                <span class="font-weight-bold">{{ company.name }}</span>
                                <br>
                                <span v-if="establishment && establishment.address != '-'">{{ establishment.address }} </span>
                                <br>
                                <span v-if="establishment && establishment.email != '-'">{{
                                        establishment.email
                                    }} </span><span v-if="establishment && establishment.telephone != '-'">- {{
                                    establishment.telephone
                                }}</span>
                            </address>
                        </div>
                        <div class="col-xl-4 col-md-4 col-12 align-self-end">
                            <div class="">
                                <div class="row">
                                    <div class="col-lg-6 align-self-end">
                                        <div :class="{'has-danger': errors.date_of_issue}"
                                             class="form-group">
                                            <label class="control-label">Fec. Emisión</label>
                                            <el-date-picker v-model="form.date_of_issue"
                                                            :clearable="false"
                                                            :picker-options="datEmision"
                                                            :readonly="readonly_date_of_due"
                                                            type="date"
                                                            value-format="yyyy-MM-dd"
                                                            @change="changeDateOfIssue"></el-date-picker>
                                            <small v-if="errors.date_of_issue"
                                                   class="form-control-feedback"
                                                   v-text="errors.date_of_issue[0]"></small>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 align-self-end">
                                        <div :class="{'has-danger': errors.date_of_due}"
                                             class="form-group">
                                            <label class="control-label">Fec. Vencimiento</label>
                                            <el-date-picker v-model="form.date_of_due"
                                                            :clearable="false"
                                                            :readonly="readonly_date_of_due"
                                                            type="date"
                                                            value-format="yyyy-MM-dd"></el-date-picker>
                                            <small v-if="errors.date_of_due"
                                                   class="form-control-feedback"
                                                   v-text="errors.date_of_due[0]"></small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body no-gutters">
                        <div class="row">
                            <div class="col-lg-4 align-self-end">
                                <div :class="{'has-danger': errors.document_type_id}"
                                     class="form-group">
                                    <label class="control-label font-weight-bold text-info">Tipo comprobante</label>
                                    <el-select v-model="form.document_type_id"
                                               class="border-left rounded-left border-info"
                                               dusk="document_type_id"
                                               popper-class="el-select-document_type"
                                               @change="changeDocumentType"
                                               :disabled="isUpdateDocument">
                                        <el-option v-for="option in document_types"
                                                   :key="option.id"
                                                   :label="option.description"
                                                   :value="option.id"></el-option>
                                    </el-select>
                                    <small v-if="errors.document_type_id"
                                           class="form-control-feedback"
                                           v-text="errors.document_type_id[0]"></small>
                                </div>
                            </div>
                            <div class="col-lg-2 d-none">
                                <div :class="{'has-danger': errors.establishment_id}"
                                     class="form-group">
                                    <label class="control-label">Establecimiento</label>
                                    <el-select v-model="form.establishment_id"
                                               @change="changeEstablishment">
                                        <el-option v-for="option in establishments"
                                                   :key="option.id"
                                                   :label="option.description"
                                                   :value="option.id"></el-option>
                                    </el-select>
                                    <small v-if="errors.establishment_id"
                                           class="form-control-feedback"
                                           v-text="errors.establishment_id[0]"></small>
                                </div>
                            </div>
                            <div class="col-lg-2 align-self-end">
                                <div :class="{'has-danger': errors.series_id}"
                                     class="form-group">
                                    <label class="control-label">Serie</label>
                                    <el-select v-model="form.series_id" :disabled="disabledSeries()">
                                        <el-option v-for="option in series"
                                                   :key="option.id"
                                                   :label="option.number"
                                                   :disabled="option.disabled"
                                                   :value="option.id"></el-option>
                                    </el-select>
                                    <small v-if="errors.series_id"
                                           class="form-control-feedback"
                                           v-text="errors.series_id[0]"></small>
                                </div>
                            </div>
                            <div class="col-lg-2 align-self-end">
                                <div :class="{'has-danger': errors.operation_type_id}"
                                     class="form-group">
                                    <label class="control-label">Tipo Operación
                                        <template
                                            v-if="(form.operation_type_id == '1001' || form.operation_type_id == '1004') && has_data_detraction">
                                            <a class="text-center font-weight-bold text-info"
                                               href="#"
                                               @click.prevent="showDialogDocumentDetraction = true"> [+ Ver datos]</a>
                                        </template>
                                        <template v-if="form.operation_type_id == '0208'">
                                            <a class="text-center font-weight-bold text-info" href="#" @click.prevent="showDialogServiceCountry = true"
                                            > [+ País: {{ form.service_country_id || '-' }}]
                                            </a>
                                        </template>
                                    </label>
                                    <el-select v-model="form.operation_type_id"
                                               @change="changeOperationType">
                                        <el-option v-for="option in operation_types"
                                                   :key="option.id"
                                                   :label="option.description"
                                                   :value="option.id"></el-option>
                                    </el-select>
                                    <small v-if="errors.operation_type_id"
                                           class="form-control-feedback"
                                           v-text="errors.operation_type_id[0]"></small>
                                </div>
                            </div>
                            <div class="col-lg-2 align-self-end">
                                <div :class="{'has-danger': errors.currency_type_id}"
                                     class="form-group">
                                    <label class="control-label">Moneda</label>
                                    <el-select v-model="form.currency_type_id"
                                               @change="changeCurrencyType">
                                        <el-option v-for="option in currency_types"
                                                   :key="option.id"
                                                   :label="option.description"
                                                   :value="option.id"></el-option>
                                    </el-select>
                                    <small v-if="errors.currency_type_id"
                                           class="form-control-feedback"
                                           v-text="errors.currency_type_id[0]"></small>
                                </div>
                            </div>
                            <div class="col-lg-2 align-self-end">
                                <div :class="{'has-danger': errors.exchange_rate_sale}"
                                     class="form-group">
                                    <label class="control-label">Tipo de cambio
                                        <el-tooltip class="item"
                                                    content="Tipo de cambio del día, extraído de SUNAT"
                                                    effect="dark"
                                                    placement="top-end">
                                            <i class="fa fa-info-circle"></i>
                                        </el-tooltip>
                                    </label>
                                    <el-input @change="changeCurrencyType" v-model="form.exchange_rate_sale"></el-input>
                                    <!-- <el-input :disabled="isUpdate" v-model="form.exchange_rate_sale"></el-input> -->
                                    <small v-if="errors.exchange_rate_sale"
                                           class="form-control-feedback"
                                           v-text="errors.exchange_rate_sale[0]"></small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body border-top no-gutters">
                        <div class="row">
                            <div :class="{'has-danger': errors.customer_id}"
                                 class="form-group col-sm-6 mb-0">
                                <label class="control-label font-weight-bold text-info">
                                    Cliente
                                    <a href="#"
                                       @click.prevent="showDialogNewPerson = true">[+ Nuevo]</a>
                                </label>
                                <el-select v-model="form.customer_id"
                                           :loading="loading_search"
                                           :remote-method="searchRemoteCustomers"
                                           class="border-left rounded-left border-info"
                                           dusk="customer_id"
                                           filterable

                                           @focus="focus_on_client = true"
                                           @blur="focus_on_client = false"
                                           placeholder="Escriba el nombre o número de documento del cliente"
                                           popper-class="el-select-customers"
                                           remote
                                           @change="changeCustomer"
                                           @keyup.enter.native="keyupCustomer"
                                           >

                                    <el-option v-for="option in customers"
                                               :key="option.id"
                                               :label="option.description"
                                               :value="option.id"></el-option>

                                </el-select>
                                <small v-if="errors.customer_id"
                                       class="form-control-feedback"
                                       v-text="errors.customer_id[0]"></small>
                            </div>
                            <div v-if="customer_addresses.length > 0"
                                 class="form-group col-sm-6 mb-0">
                                <label class="control-label font-weight-bold text-info">Dirección</label>
                                <el-select v-model="form.customer_address_id">
                                    <el-option v-for="option in customer_addresses"
                                               :key="option.id"
                                               :label="option.address"
                                               :value="option.id"></el-option>
                                </el-select>
                            </div>

                            <!-- sistema por puntos -->
                            <div v-if="config.enabled_point_system && form.customer_id" class="form-group col-sm-6 mb-0 mt-3">
                                <p class="fs-point-system">
                                    <label class="font-weight-bold text-info">Puntos acumulados:</label>
                                    <b>{{customer_accumulated_points}}</b>

                                    <template v-if="total_exchange_points > 0">
                                    - <b style="color:red">{{ total_exchange_points }}</b> = <b>{{ calculate_customer_accumulated_points }}</b>
                                    </template>
                                </p>
                                <p class="fs-point-system">
                                    <label class="font-weight-bold text-danger">Puntos por la compra:</label>
                                    <b>{{total_points_by_sale}}</b>
                                </p>
                            </div>
                            <!-- sistema por puntos -->

                        </div>
                    </div>
                    <div class="card-body border-top no-gutters">
                        <template v-if="showSearchItemsMainForm">
                            <div class="row">
                                <div class="col-md-9 mb-4" :class="{'col-md-12': configuration.enable_list_product}">
                                    <item-search-quick-sale
                                        @changeItem="changeItemQuickSale"
                                        :resource="resource"
                                        :showDetailButton="configuration.show_all_item_details"
                                        :selectedOptionPrice="selected_option_price"
                                        :configuration="config"
                                        ref="item_search_quick_sale"
                                    >
                                    </item-search-quick-sale>
                                </div>
                                <div class="col-md-3">
                                    <el-select
                                        v-if="!configuration.enable_list_product"
                                        v-model="selected_option_price"
                                        filterable
                                        style="width:100%;">
                                        <el-option
                                            v-for="option in price_options"
                                            :key="option.id"
                                            :label="option.description"
                                            :value="option.id"></el-option>
                                    </el-select>
                                </div>
                            </div>
                        </template>

                        <div class="row">

                            <div v-if="isActiveBussinessTurn('hotel')"
                                    class="col-12 col-md-3">
                                <el-tooltip class="item my-2"
                                            content="Datos personales para reserva de hospedaje"
                                            effect="dark"
                                            placement="bottom-end">
                                    <button class="btn btn-primary btn-block"
                                            @click.prevent="clickAddDocumentHotel">Datos de reserva
                                    </button>
                                </el-tooltip>
                            </div>
                            <div v-if="isActiveBussinessTurn('transport')"
                                    class="col-12 col-md-3">
                                <el-tooltip class="item my-2"
                                            content="Datos para transporte de pasajeros"
                                            effect="dark"
                                            placement="bottom-end">
                                    <button class="btn btn-primary btn-block"
                                            @click.prevent="clickAddDocumentTransport">Datos de transporte
                                    </button>
                                </el-tooltip>
                            </div>
                        </div>

                <el-collapse v-model="activePanel" accordion class="mb-2">
                    <el-collapse-item name="1">
                        <template slot="title">
                            <span class="ml-2">Información Adicional</span>
                        </template>
                        <div class="card-transparent col-xl-12 col-md-12 col-12 mt-0 mb-4">
                             <div class="row">
                            <!-- <div class="card-body p-2">
                                <div class="col-12 py-2 px-0">
                                </div>
                            </div> -->
                            <div class="col-12 col-md-4 p-2">
                                <div class="col-12 py-2 px-0">
                                    <div class="row no-gutters">
                                        <div class="col-10">¿Es comprobante de contingencia?</div>
                                        <div class="col-2">
                                            <el-switch v-model="is_contingency"
                                                       @change="changeEstablishment"></el-switch>
                                        </div>
                                    </div>
                                </div>
                                <template v-if="!is_client">
                                    <div class="col-12 py-2 px-0">
                                        <div class="row no-gutters">
                                            <div class="col-10">¿Es un pago anticipado?</div>
                                            <div class="col-2">
                                                <el-switch v-if="!prepayment_deduction"
                                                           v-model="form.has_prepayment"
                                                           @change="changeHasPrepayment"></el-switch>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 py-2 px-0">
                                        <div class="row no-gutters">
                                            <div class="col-10">Deducción de los pagos anticipados</div>
                                            <div class="col-2">
                                                <el-switch v-if="!form.has_prepayment"
                                                           v-model="prepayment_deduction"
                                                           @change="changePrepaymentDeduction"></el-switch>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <el-select v-if="form.has_prepayment || prepayment_deduction"
                                                       v-model="form.affectation_type_prepayment"
                                                       class="mb-2"
                                                       @change="changeAffectationTypePrepayment">
                                                <el-option :key="10"
                                                           :value="10"
                                                           label="Gravado"></el-option>
                                                <el-option :key="20"
                                                           :value="20"
                                                           label="Exonerado"></el-option>
                                                <el-option :key="30"
                                                           :value="30"
                                                           label="Inafecto"></el-option>
                                            </el-select>
                                        </div>
                                    </div>
                                    <template v-if="!is_client">
                                        <div v-if="prepayment_deduction"
                                             class="">
                                            <div class="form-group">
                                                <table style="width: 100%">
                                                    <tr v-for="(row,index) in form.prepayments"
                                                        :key="index">
                                                        <td>
                                                            <el-select v-model="row.document_id"
                                                                       filterable
                                                                       @change="changeDocumentPrepayment(index)">
                                                                <el-option v-for="option in prepayment_documents"
                                                                           :key="option.id"
                                                                           :label="option.description"
                                                                           :value="option.id"></el-option>
                                                            </el-select>
                                                        </td>
                                                        <td>                                                            
                                                            <!-- <el-input v-model="row.amount" -->                                                             
                                                            <el-input v-model="row.total"   
                                                                      @input="inputAmountPrepayment(index)"></el-input>
                                                        </td>
                                                        <td align="right">

                                                            <button
                                                                class="btn waves-effect waves-light btn-xs btn-danger"
                                                                type="button"
                                                                @click.prevent="clickRemovePrepayment(index)">
                                                                <i class="fa fa-trash"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <label class="control-label">
                                                    <a class=""
                                                       href="#"
                                                       @click.prevent="clickAddPrepayment"><i
                                                        class="fa fa-plus font-weight-bold text-info"></i>
                                                        <span
                                                            style="color: #777777">Agregar comprobante anticipado</span></a>
                                                </label>
                                            </div>
                                        </div>
                                    </template>

                                    <div v-if="config.active_allowance_charge && form.total > 0"
                                         class="col-12 py-2 px-0">
                                        <div class="row no-gutters">
                                            <div class="col-8"><strong>Porcentaje otros cargos</strong></div>
                                            <div class="col-4">
                                                <el-input-number v-model="config.percentage_allowance_charge"
                                                                 :min="0"
                                                                 controls-position="right"
                                                                 size="mini"
                                                                 @change="calculateTotal"></el-input-number>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="col-12 py-2 px-0"
                                         v-if="show_has_retention">
                                        <div class="row no-gutters">
                                            <div class="col-10">¿Tiene retención de igv?</div>
                                            <div class="col-2">
                                                <el-switch v-model="form.has_retention"
                                                           @change="changeRetention"></el-switch>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- <div class="col-12 py-2 px-0">
                                        <div class="row no-gutters">
                                            <div class="col-10"> Mostrar términos y condiciones.</div>
                                            <div class="col-2">
                                                <el-switch v-model="form.show_terms_condition"></el-switch>
                                            </div>

                                        </div>
                                    </div> -->
                                </template>
                            </div>

                            <div class="col-12 col-md-4 p-2 no-gutters">
                                <div class="col-12">
                                    <div :class="{'has-danger': errors.purchase_order}"
                                            class="form-group">
                                        <label class="control-label">Orden de Compra</label>
                                        <el-input
                                            v-model="form.purchase_order"
                                            type="textarea">
                                        </el-input>
                                        <small v-if="errors.purchase_order"
                                            class="form-control-feedback"
                                            v-text="errors.purchase_order[0]"></small>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label class="control-label">Observaciones</label>
                                            <el-input
                                                v-model="form.additional_information"
                                                autosize
                                                type="textarea">
                                            </el-input>
                                    </div>
                                </div>
                                <div class="col-12">
                                <div :class="{'has-danger': errors.plate_number}"
                                    class="form-group">
                                    <label class="control-label">N° Placa</label>
                                    <el-input v-model="form.plate_number"
                                        type="textarea">
                                    </el-input>
                                    <small v-if="errors.plate_number"
                                        class="form-control-feedback"
                                        v-text="errors.plate_number[0]"></small>
                                </div>
                                </div>


                            </div>
                            <div class="col-12 col-md-4 p-2">
                                    <div class="form-group">
                                     <label class="control-label">Vendedor</label>
                                            <el-select v-model="form.seller_id"
                                                :disabled="typeUser == 'seller'">
                                                <el-option v-for="option in sellers"
                                                    :key="option.id"
                                                    :label="option.name"
                                                    :value="option.id"></el-option>
                                            </el-select>
                                    </div>
                                            <template v-if="!isActiveBussinessTurn('tap')">
                                                <template v-if="!is_client">
                                                    <div class="form-group">
                                                        <label class="control-label">
                                                            Guías
                                                        </label>
                                                        <table style="width: 100%">
                                                            <tr v-for="(guide,index) in form.guides">
                                                                <td>
                                                                    <el-select v-model="guide.document_type_id">
                                                                        <el-option
                                                                            v-for="option in document_types_guide"
                                                                            :key="option.id"
                                                                            :label="option.description"
                                                                            :value="option.id"></el-option>
                                                                    </el-select>
                                                                </td>
                                                                <td>
                                                                    <el-input v-model="guide.number"></el-input>
                                                                </td>
                                                                <td align="right">
                                                                    <button
                                                                        class="btn waves-effect waves-light btn-xs btn-danger"
                                                                        type="button"
                                                                        @click.prevent="clickRemoveGuide(index)">
                                                                        <i class="fa fa-trash"></i>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td colspan="3">
                                                                    <label class="control-label">
                                                                        <a class=""
                                                                           href="#"
                                                                           @click.prevent="clickAddGuide"><i
                                                                            class="fa fa-plus font-weight-bold text-info"></i>
                                                                            <span
                                                                                style="color: #777777">Agregar guía</span></a>

                                                                    </label>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <template v-if="!is_client">
                                                    <div class="form-group">
                                                        <label class="control-label">
                                                            Guías
                                                        </label>
                                                        <table style="width: 100%">
                                                            <tr v-for="(guide,index) in form.guides">
                                                                <td>
                                                                    <el-select v-model="guide.document_type_id">
                                                                        <el-option
                                                                            v-for="option in document_types_guide"
                                                                            :key="option.id"
                                                                            :label="option.description"
                                                                            :value="option.id"></el-option>
                                                                    </el-select>
                                                                </td>
                                                                <td>
                                                                    <el-input v-model="guide.number"></el-input>
                                                                </td>
                                                                <td align="right">
                                                                    <button
                                                                        class="btn waves-effect waves-light btn-xs btn-danger"
                                                                        type="button"
                                                                        @click.prevent="clickRemoveGuide(index)">
                                                                        <i class="fa fa-trash"></i>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td colspan="3">
                                                                    <label class="control-label">
                                                                        <a class=""
                                                                           href="#"
                                                                           @click.prevent="clickAddGuide"><i
                                                                            class="fa fa-plus font-weight-bold text-info"></i>
                                                                            <span
                                                                                style="color: #777777">Agregar guía</span></a>

                                                                    </label>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </template>
                                            </template>
                                        <!-- propinas -->
                                        <template v-if="config.enabled_tips_pos && !isUpdateDocument">
                                            <set-tip class="full py-2 border-top mb-1 mt-2" @changeDataTip="changeDataTip"></set-tip>
                                        </template>
                                        <!-- propinas -->

                            </div>
                            
                            <div class="d-flex col-12 justify-content-center">
                                <div class="w-md-50">
                                    <button class="btn btn-primary btn-block mt-2"
                                        :disabled="form.customer_id == null"
                                        @click.prevent="visibleDialogReportCustomer">Consulta de documentos
                                    </button>
                                </div>
                            </div>
                             </div>

                        </div>

                </el-collapse-item>
            </el-collapse>
                        <div class="table-responsive" v-loading="loading_items">
                            <table class="table table-sm">
                                <thead>
                                <tr>
                                    <th width="3%">#</th>
                                    <th class="font-weight-bold"
                                        width="30%">Descripción
                                    </th>
                                    <th class="text-center font-weight-bold">Unidad</th>
                                    <th class="text-right font-weight-bold">Cantidad</th>
                                    <th class="text-right font-weight-bold">Valor Unitario</th>
                                    <th class="text-right font-weight-bold">Precio Unitario</th>
                                    <th class="text-right font-weight-bold">Subtotal</th>
                                    <!--<th class="text-right font-weight-bold">Cargo</th>-->
                                    <th class="text-right font-weight-bold">Total</th>
                                    <th v-if="config.change_free_affectation_igv" width="8%"></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(row, index) in form.items"
                                    :key="index">
                                    <td>{{ index + 1 }}</td>
                                    <td>
                                        <template v-if="canAddDescriptionToDocumentItem">
                                            <template v-if="row.name_product_pdf && row.name_product_pdf != ''">
                                                <label v-html="row.name_product_pdf"></label>
                                            </template>
                                            <template v-else>
                                                <label><p v-text="setDescriptionOfItem(row.item)"></p></label>
                                            </template>
                                        </template>
                                        <template v-else>
                                            {{ setDescriptionOfItem(row.item) }}
                                        </template>

                                        <pack-item-description
                                            v-if="row.item.is_set && configuration.show_item_description_pack"
                                            :item-id="row.item_id"
                                        >
                                        </pack-item-description>

                                        {{
                                            row.item.presentation.hasOwnProperty('description') ?
                                                row.item.presentation.description : ''
                                        }}
                                        <template v-if="row.total_plastic_bag_taxes > 0">
                                            <br/><small>ICBPER: {{ currency_type.symbol }}
                                            {{ row.total_plastic_bag_taxes }}</small>
                                        </template>
                                        <br/><small>{{ row.affectation_igv_type.description }}</small>
                                        <template v-if="row.item.lots && row.item.lots.length > 0">
                                            <br/>Series: {{ showItemSeries(row.item.lots) }}
                                        </template>

                                        <!-- sistema por puntos -->
                                        <template v-if="config.enabled_point_system && customer_accumulated_points > 0 && row.item.exchange_points">
                                            <el-checkbox class="mt-2 mb-2" v-model="row.item.exchanged_for_points" @change="changeRowExchangePoints(row, index)"><b>{{ getExchangePointDescription(row) }}</b></el-checkbox>
                                        </template>
                                        <!-- sistema por puntos -->

                                        <template v-if="fnApplyRestrictSaleItemsCpe && isGeneratedFromExternal">
                                            <template v-if="fnIsRestrictedForSale(row.item, form.document_type_id)">
                                                <span class="text-danger mt-1 mb-2 d-block">Restringido para venta en CPE</span>
                                            </template>
                                        </template>

                                        <p class="control-label font-weight-bold text-info">
                                            <a v-if="configuration.show_all_item_details" class="btn btn-default btn-xs" href="#" @click.prevent="clickShowItemDetail(row.item_id)">Ver detalle</a>
                                            <button class="btn waves-effect waves-light btn-xs btn-outline-info"
                                                type="button"
                                                @click="ediItem(row, index)"
                                                :disabled="has_sale_note">
                                            <i class="fas fa-edit"></i></button>
                                            <button class="btn waves-effect waves-light btn-xs btn-outline-danger"
                                                type="button"
                                                @click.prevent="clickRemoveItem(index)"
                                                :disabled="has_sale_note"><i class="fas fa-trash"></i>
                                            </button>
                                        </p>

                                    </td>
                                    <td class="text-center">{{ row.item.unit_type_id }}</td>

                                    <td class="text-right">
                                        <template v-if="showEditableItems">
                                            <div @keydown.enter="handleEnterKey($event)">
                                                <el-input-number
                                                    v-model="row.quantity"
                                                    :min="0.01"
                                                    class="input-custom"
                                                    :controls="false"
                                                    style="min-width: 98px !important"
                                                    :disabled="hasRowAdvancedOption(row)"
                                                    @change="changeRowQuantity(row)"
                                                    @focus="valueInputSelect($event)"
                                                    >
                                                </el-input-number>
                                            </div>
                                        </template>
                                        <template v-else>
                                            {{ row.quantity }}
                                        </template>

                                    </td>

                                    <td class="text-right">
                                        <template v-if="showEditableItems">
                                            <span class="currency">{{ currency_type.symbol }}</span>
                                            <div @keydown.enter="handleEnterKey($event)">
                                                <el-input-number
                                                    v-model="row.unit_value"
                                                    :min="0"
                                                    class="input-custom"
                                                    :controls="false"
                                                    style="min-width: 98px !important"
                                                    :disabled="hasRowAdvancedOption(row) || !hasPermissionEditItemPrices(authUser.permission_edit_item_prices)"
                                                    @change="changeRowUnitValue(row)"
                                                    @focus="valueInputSelect($event)"
                                                    >
                                                </el-input-number>
                                            </div>
                                        </template>
                                        <template v-else>
                                            {{ currency_type.symbol }} {{ getFormatUnitPriceRow(row.unit_value) }}
                                        </template>
                                    </td>

                                    <td class="text-right">
                                        <template v-if="showEditableItems">
                                            <span class="currency">{{ currency_type.symbol }}</span>
                                            <div @keydown.enter="handleEnterKey($event)">
                                                <el-input-number
                                                    v-model="row.unit_price"
                                                    :min="0.01"
                                                    class="input-custom"
                                                    :controls="false"
                                                    style="min-width: 98px !important"
                                                    :disabled="hasRowAdvancedOption(row) || !hasPermissionEditItemPrices(authUser.permission_edit_item_prices)"
                                                    @change="changeRowUnitPrice(row)"
                                                    @focus="valueInputSelect($event)"
                                                    >
                                                </el-input-number>
                                            </div>
                                        </template>
                                        <template v-else>
                                            {{ currency_type.symbol }} {{ getFormatUnitPriceRow(row.unit_price) }}
                                        </template>
                                    </td>


                                    <td class="text-right">
                                        <template v-if="showEditableItems">
                                            <span class="currency">{{ currency_type.symbol }}</span>
                                            <div @keydown.enter="handleEnterKey($event)">
                                                <el-input-number
                                                    v-model="row.total_value"
                                                    :min="0.01"
                                                    class="input-custom"
                                                    :controls="false"
                                                    style="min-width: 98px !important"
                                                    :disabled="hasRowAdvancedOption(row) || !hasPermissionEditItemPrices(authUser.permission_edit_item_prices)"
                                                    @change="changeRowTotalValue(row)"
                                                    @focus="valueInputSelect($event)"
                                                    >

                                                </el-input-number>
                                            </div>
                                        </template>
                                        <template v-else>
                                            {{ currency_type.symbol }} {{ row.total_value }}
                                        </template>
                                    </td>

                                    <td class="text-right">


                                        <template v-if="showEditableItems">
                                            <span class="currency">{{ currency_type.symbol }}</span>
                                            <div @keydown.enter="handleEnterKey($event)">
                                                <el-input-number
                                                    v-model="row.total"
                                                    :min="0"
                                                    class="input-custom"
                                                    :controls="false"
                                                    style="min-width: 98px !important"
                                                    :disabled="hasRowAdvancedOption(row) || !hasPermissionEditItemPrices(authUser.permission_edit_item_prices)"
                                                    @change="changeRowTotal(row)"
                                                    @focus="valueInputSelect($event)"
                                                    >

                                                </el-input-number>
                                            </div>
                                        </template>
                                        <template v-else>
                                            {{ currency_type.symbol }} {{ row.total }}
                                        </template>
                                    </td>


                                    <td class="text-right">
                                        <template v-if="config.change_free_affectation_igv">
                                            <el-tooltip class="item"
                                                        content="Modificar afectación Gravado – Bonificaciones"
                                                        effect="dark"
                                                        placement="top-start">
                                                <el-checkbox v-model="row.item.change_free_affectation_igv"
                                                             @change="changeRowFreeAffectationIgv(row, index)"></el-checkbox>
                                            </el-tooltip>
                                        </template>
                                        <!-- <button type="button" class="btn waves-effect waves-light btn-xs btn-success"
                                                @click.prevent="openDialogLots(row)"
                                                v-if="row.item.series_enabled">
                                            <i class="el-icon-check"></i> Series
                                        </button> -->
                                    </td>

                                </tr>

                                <!-- @todo: Mejorar evitando duplicar codigo -->
                                <!-- Ocultar en cel -->
                                <tr>

                                    <td class="pt-3"
                                        colspan="4">
                                        <el-popover
                                            placement="top-start"
                                            :open-delay="1000"
                                            width="145"
                                            trigger="hover"
                                            content="Presiona F2">
                                            <el-button slot="reference"
                                                class="btn waves-effect waves-light btn-primary hidden-sm-down"
                                                type="button"
                                                @click.prevent="clickAddItemInvoice"
                                                :disabled="has_sale_note">
                                                Agregar Producto <kbd>F2</kbd>
                                            </el-button>
                                        </el-popover>
                                        <!-- <el-select
                                            v-if="!configuration.enable_list_product"
                                            v-model="selected_option_price"
                                            filterable
                                            style="width:50%;">
                                            <el-option
                                                v-for="option in price_options"
                                                :key="option.id"
                                                :label="option.description"
                                                :value="option.id"></el-option>
                                        </el-select> -->
                                    </td>
                                    <td class="p-0"
                                        colspan="5">
                                        <div class="row table-responsive">
                                            <table class="table-sm text-right hidden-sm-down"
                                                   style="width: 100%;"
                                                   v-if="form.items.length > 0"
                                                >
                                                <tr v-if="form.total > 0 && enabled_discount_global && !configuration.activate_tip_charge">
                                                    <td>
                                                        <el-tooltip class="item"
                                                            :content="global_discount_type.description"
                                                            effect="dark"
                                                            placement="top">
                                                            <i class="fa fa-info-circle"></i>
                                                        </el-tooltip>

                                                        DESCUENTO
                                                        <template v-if="is_amount"> MONTO</template>
                                                        <template v-else> %</template>
                                                        <el-checkbox v-model="is_amount"
                                                                     class="ml-1 mr-1"
                                                                     @change="changeTypeDiscount"
                                                                     :disabled="has_sale_note"
                                                                     ></el-checkbox>
                                                        :
                                                    </td>
                                                    <td>

                                                        <el-input-number v-model="total_global_discount"
                                                                         :min="0"
                                                                         class="input-custom"
                                                                         controls-position="right"
                                                                         @change="changeTotalGlobalDiscount"
                                                                         :disabled="has_sale_note"
                                                                         ></el-input-number>

                                                        <!-- <el-input v-model="total_global_discount"
                                                                  class="input-custom"
                                                                  @input="calculateTotal"></el-input> -->
                                                    </td>
                                                </tr>

                                                <template v-if="form.detraction">
                                                    <tr v-if="form.detraction.amount > 0">
                                                        <td width="60%">M. DETRACCIÓN:</td>
                                                        <td>S/ {{ form.detraction.amount }}</td>
                                                        <!-- <td>{{ currency_type.symbol }} {{ form.detraction.amount }}</td> -->
                                                    </tr>
                                                </template>

<!--                                                <template v-if="form.retention">-->
<!--                                                    <tr v-if="form.retention.amount > 0">-->
<!--                                                        <td>M. RETENCIÓN ({{ form.retention.percentage * 100 }}%):</td>-->
<!--                                                        <td>{{ currency_type.symbol }} {{ form.retention.amount }}</td>-->
<!--                                                    </tr>-->
<!--                                                </template>-->

                                                <tr v-if="form.total_exportation > 0">
                                                    <td>OP.EXPORTACIÓN:</td>
                                                    <td>{{ currency_type.symbol }} {{ form.total_exportation }}</td>
                                                </tr>
                                                <tr v-if="form.total_free > 0">
                                                    <td>OP.GRATUITAS:</td>
                                                    <td>{{ currency_type.symbol }} {{ form.total_free }}</td>
                                                </tr>
                                                <tr v-if="form.total_unaffected > 0">
                                                    <td>OP.INAFECTAS:</td>
                                                    <td>{{ currency_type.symbol }} {{ totalUnaffectedOnlyVisual  }}</td>
                                                </tr>
                                                <tr v-if="form.total_exonerated > 0">
                                                    <td>OP.EXONERADAS:</td>
                                                    <td>{{ currency_type.symbol }} {{ totalExoneratedOnlyVisual  }}</td>
                                                </tr>
                                                <tr v-if="form.total_taxed > 0">
                                                    <td>OP.GRAVADA:</td>
                                                    <td>{{ currency_type.symbol }} {{ form.total_taxed }}</td>
                                                </tr>
                                                <tr v-if="form.total_prepayment > 0">
                                                    <td>ANTICIPOS:</td>
                                                    <td>{{ currency_type.symbol }} {{ form.total_prepayment }}</td>
                                                    <!-- <td>{{ currency_type.symbol }} {{ form.total_prepayment }}</td> -->
                                                </tr>
                                                <tr v-if="form.total_igv > 0">
                                                    <td>IGV:</td>
                                                    <td>{{ currency_type.symbol }} {{ form.total_igv }}</td>
                                                </tr>
                                                <tr v-if="form.total_isc > 0">
                                                    <td>ISC:</td>
                                                    <td>{{ currency_type.symbol }} {{ form.total_isc }}</td>
                                                </tr>
                                                <tr v-if="form.total_plastic_bag_taxes > 0">
                                                    <td>ICBPER:</td>
                                                    <td>{{ currency_type.symbol }} {{
                                                            form.total_plastic_bag_taxes
                                                        }}
                                                    </td>
                                                </tr>

                                                <tr v-if="form.subtotal > 0 && form.total_discount > 0">
                                                    <td>SUBTOTAL:</td>
                                                    <td>{{ currency_type.symbol }} {{ totalExoneratedOnlyVisual+totalUnaffectedOnlyVisual+form.total_taxed }}</td>
                                                </tr>

                                                <!-- <tr v-if="form.total_discount > 0"> -->
                                                <tr v-if="totalDiscountOnlyVisual > 0">
                                                    <td>DESCUENTOS TOTALES:</td>
                                                    <!-- <td>{{ currency_type.symbol }} {{ form.total_discount }}</td> -->
                                                    <td>{{ currency_type.symbol }} {{ totalDiscountOnlyVisual }}</td>
                                                </tr>

                                                <tr v-if="form.total > 0">
                                                    <td>
                                                        OTROS CARGOS - R.C. <el-tooltip content="R.C.: Recargo por Consumo" effect="dark" placement="top-start">
                                                            <i class="fa fa-info-circle"></i>
                                                        </el-tooltip>
                                                        <el-checkbox v-model="configuration.allow_charge_is_amount" @change="calculateTotal"
                                                            :disabled="has_sale_note"
                                                        ></el-checkbox>:
                                                    </td>
                                                    <td>{{ configuration.allow_charge_is_amount ? currency_type.symbol : '%' }}
                                                        <!-- :disabled="config.active_allowance_charge == true ? true:false" -->

                                                        <!-- v-model="total_global_charge" -->
                                                        <el-input-number v-model="percentage_allowance_charge_user"
                                                                         :min="0"
                                                                         class="input-custom"
                                                                         controls-position="right"
                                                                         @change="calculateTotal"
                                                                         :disabled="has_sale_note"
                                                                         ></el-input-number>
                                                    </td>
                                                </tr>

                                                <tr v-if="form.total_charge_46">
                                                    <td>
                                                        MONTO RECARGO - PROPINA TOTAL 
                                                        
                                                    </td>
                                                    <td>
                                                        {{ currency_type.symbol }} {{ form.total_charge_46 }}
                                                    </td>
                                                </tr>

<!--                                                <tr v-if="form.total > 0">-->
<!--                                                    <td><strong>TOTAL A PAGAR</strong>:</td>-->
<!--                                                    <td>{{ currency_type.symbol }} {{ form.total }}</td>-->
<!--                                                </tr>-->

                                                <template v-if="form.has_retention">
                                                    <tr v-if="form.total > 0">
                                                        <td><strong>IMPORTE TOTAL</strong>:</td>
                                                        <td>{{ currency_type.symbol }} {{ form.total }}</td>
                                                    </tr>
                                                    <tr v-if="form.retention.amount > 0">
                                                        <td>M. RETENCIÓN ({{form.retention.percentage * 100}}%):</td>
                                                        <td>{{ currency_type.symbol }} {{ form.retention.amount }}</td>
                                                    </tr>
                                                    <tr v-if="form.total > 0">
                                                        <td><strong>TOTAL A PAGAR</strong>:</td>
                                                        <td>{{ currency_type.symbol }} {{ form.total - form.retention.amount }}</td>
                                                    </tr>
                                                </template>


                                                <tr v-if="form.items.length > 0">
                                                    <td>
                                                        <el-tooltip content="El redondeo debe ser un valor entre -0.99 y 0.99" effect="dark" placement="top-start">
                                                            <i class="fa fa-info-circle"></i>
                                                        </el-tooltip>
                                                        Redondeo:</td>
                                                    <td>{{ currency_type.symbol }}
                                                        <el-input-number v-model="form.rounding" 
                                                            :min="-0.99"
                                                            :max="0.99"
                                                            :step="0.01"
                                                            class="input-custom"
                                                            controls-position="right"
                                                            @change="addRounding"
                                                            @blur="checkRounding"
                                                            :disabled="has_sale_note"
                                                            ></el-input-number>
                                                    </td>
                                                </tr>


                                                <template v-if="!form.has_retention">
                                                    <tr v-if="form.total > 0">
                                                        <td><strong>TOTAL A PAGAR</strong>:</td>
                                                        <td>{{ currency_type.symbol }} {{ form.total }}</td>
                                                    </tr>
                                                </template>

                                                <tr v-if="form.total > 0">
                                                    <td>CONDICIÓN DE PAGO:</td>
                                                    <td>
                                                        <el-select v-model="form.payment_condition_id"
                                                                   dusk="document_type_id"
                                                                   popper-class="el-select-document_type"
                                                                   style="max-width: 200px;"
                                                                   @change="changePaymentCondition">
                                                            <el-option label="Crédito con cuotas"
                                                                       value="03"></el-option>
                                                            <el-option label="Crédito"
                                                                       value="02"></el-option>
                                                            <el-option label="Contado"
                                                                       value="01"></el-option>
                                                        </el-select>
                                                    </td>
                                                </tr>


                                                <!-- <template v-if="form.detraction">
                                                    <tr v-if="form.detraction.amount > 0 && form.total_pending_payment > 0">
                                                        <td width="60%">M. PENDIENTE:</td>
                                                        <td>{{ currency_type.symbol }} {{ form.total_pending_payment }}</td>
                                                    </tr>
                                                </template> -->

                                                <template v-if="form.detraction || form.retention">
                                                    <tr v-if="has_pending_payment_base">
                                                        <!-- <tr v-if="form.detraction.amount > 0 && form.total_pending_payment > 0"> -->
                                                        <td>M. PENDIENTE:</td>
                                                        <td>{{ currency_type.symbol }} 
                                                            <el-input-number v-model="form.total_pending_payment" 
                                                                :min="0" 
                                                                :max="max_total_pending_payment"
                                                                :step="0.01"
                                                                :precision="2"
                                                                class="input-custom"
                                                                controls-position="right"
                                                                @change="changeTotalPendingPayment"
                                                                @blur="checkTotalPendingPayment"
                                                                :disabled="has_sale_note"
                                                                >
                                                            </el-input-number>
                                                    </td>
                                                    </tr>
                                                </template>

                                                <tr v-if="has_sale_note">
                                                    <td colspan="2" class="text-left">
                                                        Pagos referenciales
                                                        <el-tooltip content="Los pagos referenciales, no afectan flujos de caja entre otros. Sirven para autocompletar la información al convertirlo a Comprobante electrónico."
                                                            placement="top">
                                                            <i class="fa fa-info-circle"></i>
                                                        </el-tooltip>
                                                    </td>
                                                </tr>

                                                <tr v-if="form.total > 0">
                                                    <!-- Metodos de pago -->
                                                    <td class="p-0"
                                                        colspan="2">
                                                        <!-- Crédito con cuotas -->
                                                        <div v-if="form.payment_condition_id === '03'"
                                                             class="table-responsive">
                                                            <table
                                                                   class="text-left table"
                                                                   width="100%">
                                                                <thead>
                                                                <tr v-if="form.fee.length > 0">
                                                                    <th class="text-left"
                                                                        style="width: 100px">Fecha
                                                                        <el-tooltip content="Fecha del pago de las cuotas no puede ser anterior o el mismo día a la fecha de emisión del comprobante."
                                                                                    placement="top">
                                                                            <i class="fa fa-info-circle"></i>
                                                                        </el-tooltip>
                                                                    </th>
                                                                    <th class="text-left"
                                                                        style="width: 100px">Monto
                                                                    </th>
                                                                    <th style="width: 30px"></th>
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                <tr v-for="(row, index) in form.fee"
                                                                    :key="index">
                                                                    <td>
                                                                        <el-date-picker v-model="row.date"
                                                                                        :clearable="false"
                                                                                        format="dd/MM/yyyy"
                                                                                        type="date"
                                                                                        :picker-options="getMinDatePickerOptions(form.date_of_issue, 1)"
                                                                                        @change="changeCreditFeeDate(index)"
                                                                                        value-format="yyyy-MM-dd"></el-date-picker>
                                                                    </td>
                                                                    <td>
                                                                        <el-input v-model="row.amount"></el-input>
                                                                    </td>
                                                                    <td class="text-center">
                                                                        <button v-if="index > 0"
                                                                                class="btn waves-effect waves-light btn-xs btn-danger"
                                                                                type="button"
                                                                                @click.prevent="clickRemoveFee(index)">
                                                                            <i class="fa fa-trash"></i>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td colspan="5">
                                                                        <label class="control-label">
                                                                            <a class=""
                                                                               href="#"
                                                                               @click.prevent="clickAddFee"><i
                                                                                class="fa fa-plus font-weight-bold text-info"></i>
                                                                                <span style="color: #777777">Agregar cuota</span></a>

                                                                        </label>
                                                                    </td>
                                                                </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <!-- Credito -->
                                                        <div v-if="form.payment_condition_id === '02'"
                                                             class="table-responsive">
                                                            <table v-if="form.fee.length>0"
                                                                   class="text-left table"
                                                                   width="100%">
                                                                <thead>
                                                                <tr>
                                                                    <th v-if="form.fee.length>0"
                                                                        style="width: 120px">Método de pago
                                                                    </th>
                                                                    <th class="text-left"
                                                                        style="width: 100px">Fecha
                                                                    </th>
                                                                    <th class="text-left"
                                                                        style="width: 100px">Monto
                                                                    </th>
                                                                    <th style="width: 30px"></th>
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                <tr v-for="(row, index) in form.fee"
                                                                    :key="index">
                                                                    <td>
                                                                        <el-select
                                                                            v-model="row.payment_method_type_id"
                                                                            @change="changePaymentMethodType(index)">
                                                                            <el-option
                                                                                v-for="option in credit_payment_metod"
                                                                                :key="option.id"
                                                                                :label="option.description"
                                                                                :value="option.id"
                                                                            ></el-option>
                                                                        </el-select>
                                                                    </td>
                                                                    <td>
                                                                        <el-date-picker
                                                                            v-model="row.date"
                                                                            :clearable="false"
                                                                            format="dd/MM/yyyy"
                                                                            type="date"
                                                                            value-format="yyyy-MM-dd"
                                                                            :readonly="row.payment_method_type_id !== '09'">
                                                                        </el-date-picker>
                                                                    </td>
                                                                    <td>
                                                                        <el-input v-model="row.amount" :readonly="true"></el-input>
                                                                    </td>
                                                                </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <!-- Contado -->
                                                        <div v-if="!is_receivable && form.payment_condition_id === '01'"
                                                             class="table-responsive payment">
                                                            <table class="text-left table">
                                                                <thead>
                                                                <tr>
                                                                    <template v-if="showLoadVoucher && form.payments.length>0">
                                                                        <th style="width:50px">Voucher</th>
                                                                    </template>

                                                                    <th v-if="form.payments.length>0"
                                                                        style="width: 120px">Método de pago
                                                                    </th>
                                                                    <template v-if="enabled_payments">
                                                                        <th v-if="form.payments.length>0"
                                                                            style="width: 120px">Destino
                                                                            <el-tooltip class="item"
                                                                                        content="Aperture caja o cuentas bancarias"
                                                                                        effect="dark"
                                                                                        placement="top-start">
                                                                                <i class="fa fa-info-circle"></i>
                                                                            </el-tooltip>
                                                                        </th>
                                                                        <th v-if="form.payments.length>0"
                                                                            style="width: 100px">Referencia
                                                                        </th>
                                                                        <th v-if="form.payments.length>0"
                                                                            style="width: 100px">Monto
                                                                            <el-tooltip class="item"
                                                                                    content="Cuando esta marcado se calcula el monto automáticamente"
                                                                                    effect="dark"
                                                                                    placement="top-start"
                                                                            >
                                                                                <i class="fa fa-info-circle"></i>
                                                                            </el-tooltip>
                                                                            <br>
                                                                            <el-checkbox label="Calcular monto"
                                                                                v-model="auto_calculate_amount"
                                                                            ></el-checkbox>

                                                                        </th>
                                                                        <th style="width: 30px"></th>
                                                                    </template>
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                <tr v-for="(row, index) in form.payments"
                                                                    :key="index">

                                                                    <template v-if="showLoadVoucher">
                                                                        <td class="" style="width: 50px">
                                                                            <!-- <el-tooltip class="item" content="Cargar voucher" effect="dark" placement="top-start"> -->
                                                                                <el-upload
                                                                                    :data="{'index': index}"
                                                                                    :headers="headers_token"
                                                                                    :multiple="false"
                                                                                    :on-remove="(file, fileList) => handleRemoveUploadVoucher(file, fileList, index)"
                                                                                    :action="`/finances/payment-file/upload`"
                                                                                    :show-file-list="true"
                                                                                    :file-list="row.file_list"
                                                                                    :on-success="(response, file, fileList) => onSuccessUploadVoucher(response, file, fileList, index)"
                                                                                    :limit="1"
                                                                                    >
                                                                                        <button  type="button" class="btn btn-sm btn-primary"  slot="trigger">
                                                                                            <i class="fas fa-fw fa-upload"></i>
                                                                                        </button>
                                                                                </el-upload>
                                                                            <!-- </el-tooltip> -->
                                                                        </td>
                                                                    </template>

                                                                    <td>
                                                                        <el-select
                                                                            v-model="row.payment_method_type_id"
                                                                            @change="changePaymentMethodType(index)">
                                                                            <el-option
                                                                                v-for="option in cash_payment_metod"
                                                                                :key="option.id"
                                                                                :label="option.description"
                                                                                :value="option.id"></el-option>
                                                                        </el-select>
                                                                    </td>
                                                                    <template v-if="enabled_payments">
                                                                        <td>
                                                                            <el-select
                                                                                v-model="row.payment_destination_id"
                                                                                filterable>
                                                                                <el-option
                                                                                    v-for="option in payment_destinations"
                                                                                    :key="option.id"
                                                                                    :label="option.description"
                                                                                    :value="option.id"></el-option>
                                                                            </el-select>
                                                                        </td>
                                                                        <td>
                                                                            <el-input
                                                                                v-model="row.reference"></el-input>
                                                                        </td>
                                                                        <td>
                                                                            <el-input v-model="row.payment"
                                                                                @blur="recalculateTotalForPayment(index)"
                                                                            ></el-input>
                                                                        </td>


                                                                        <td class="text-center">
                                                                            <button
                                                                                class="btn waves-effect waves-light btn-xs btn-danger"
                                                                                type="button"
                                                                                @click.prevent="clickCancel(index)">
                                                                                <i class="fa fa-trash"></i>
                                                                            </button>
                                                                        </td>
                                                                    </template>
                                                                </tr>
                                                                <tr>
                                                                    <td colspan="5">
                                                                        <label class="control-label">
                                                                            <a class=""
                                                                               href="#"
                                                                               @click.prevent="clickAddPayment"><i
                                                                                class="fa fa-plus font-weight-bold text-info"></i>
                                                                                <span style="color: #777777">Agregar pago</span></a>

                                                                        </label>
                                                                    </td>
                                                                </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </td>
                                                </tr>

                                            </table>
                                        </div>
                                    </td>
                                </tr>
                                <!-- @todo: Mejorar evitando duplicar codigo -->
                                <!-- Ocultar en cel -->
                                </tbody>
                            </table>
                        </div>
                        <!-- @todo: Mejorar evitando duplicar codigo -->
                        <!-- Mostrar en cel -->
                        <div class="row hidden-md-up">
                            <div class="col-12 text-center">

                                <button class="btn waves-effect waves-light btn-primary btn-sm"
                                        style="width: 180px;"
                                        type="button"
                                        @click.prevent="clickAddItemInvoice"
                                        :disabled="has_sale_note"
                                        >+ Agregar Producto
                                </button>
                            </div>

                            <div class="col-12 text-center table-responsive">
                                <table class="table table-sm text-right"
                                       style="width: 100%;">
                                    <tr v-if="form.total > 0 && enabled_discount_global && !configuration.activate_tip_charge">
                                        <td>
                                            <el-tooltip class="item"
                                                :content="global_discount_type.description"
                                                effect="dark"
                                                placement="top">
                                                <i class="fa fa-info-circle"></i>
                                            </el-tooltip>

                                            DESCUENTO
                                            <template v-if="is_amount"> MONTO</template>
                                            <template v-else> %</template>
                                            <el-checkbox v-model="is_amount"
                                                         class="ml-1 mr-1"
                                                         @change="changeTypeDiscount"></el-checkbox>
                                            :
                                        </td>
                                        <td>

                                            <el-input-number v-model="total_global_discount"
                                                             :min="0"
                                                             class="input-custom"
                                                             controls-position="right"
                                                             @change="changeTotalGlobalDiscount"></el-input-number>

                                            <!-- <el-input v-model="total_global_discount"
                                                      class="input-custom"
                                                      @input="calculateTotal"></el-input> -->
                                        </td>
                                    </tr>

                                    <template v-if="form.detraction">
                                        <tr v-if="form.detraction.amount > 0">
                                            <td width="60%">M. DETRACCIÓN:</td>
                                            <td>S/ {{ form.detraction.amount }}</td>
                                        </tr>
                                    </template>

                                    <template v-if="form.retention">
                                        <tr v-if="form.retention.amount > 0">
                                            <td>M. RETENCIÓN ({{ form.retention.percentage * 100 }}%):</td>
                                            <td>{{ currency_type.symbol }} {{ form.retention.amount }}</td>
                                        </tr>
                                    </template>

                                    <tr v-if="form.total_exportation > 0">
                                        <td>OP.EXPORTACIÓN:</td>
                                        <td>{{ currency_type.symbol }} {{ form.total_exportation }}</td>
                                    </tr>
                                    <tr v-if="form.total_free > 0">
                                        <td>OP.GRATUITAS:</td>
                                        <td>{{ currency_type.symbol }} {{ form.total_free }}</td>
                                    </tr>
                                    <tr v-if="form.total_unaffected > 0">
                                        <td>OP.INAFECTAS:</td>
                                        <td>{{ currency_type.symbol }} {{ form.total_unaffected }}</td>
                                    </tr>
                                    <tr v-if="form.total_exonerated > 0">
                                        <td>OP.EXONERADAS:</td>
                                        <td>{{ currency_type.symbol }} {{ form.total_exonerated }}</td>
                                    </tr>
                                    <tr v-if="form.total_taxed > 0">
                                        <td>OP.GRAVADA:</td>
                                        <td>{{ currency_type.symbol }} {{ form.total_taxed }}</td>
                                    </tr>
                                    <tr v-if="form.total_prepayment > 0">
                                        <td>ANTICIPOS:</td>
                                        <td>{{ currency_type.symbol }} {{ form.total_prepayment }}</td>
                                    </tr>
                                    <tr v-if="form.total_igv > 0">
                                        <td>IGV:</td>
                                        <td>{{ currency_type.symbol }} {{ form.total_igv }}</td>
                                    </tr>
                                    <tr v-if="form.total_isc > 0">
                                        <td>ISC:</td>
                                        <td>{{ currency_type.symbol }} {{ form.total_isc }}</td>
                                    </tr>
                                    <tr v-if="form.total_plastic_bag_taxes > 0">
                                        <td>ICBPER:</td>
                                        <td>{{ currency_type.symbol }} {{ form.total_plastic_bag_taxes }}</td>
                                    </tr>

                                    <tr v-if="form.subtotal > 0 && form.total_discount > 0">
                                        <td>SUBTOTAL:</td>
                                        <td>{{ currency_type.symbol }} {{ form.subtotal }}</td>
                                    </tr>

                                    <!-- <tr v-if="form.total_discount > 0"> -->
                                    <tr v-if="totalDiscountOnlyVisual > 0">
                                        <td>DESCUENTOS TOTALES:</td>
                                        <!-- <td>{{ currency_type.symbol }} {{ form.total_discount }}</td> -->
                                        <td>{{ currency_type.symbol }} {{ totalDiscountOnlyVisual }}</td>
                                    </tr>

                                    <tr v-if="form.total > 0">
                                        <td>
                                            OTROS CARGOS - R.C. <el-tooltip content="R.C.: Recargo por Consumo" effect="dark" placement="top-start">
                                                            <i class="fa fa-info-circle"></i>
                                                        </el-tooltip>
                                            <el-checkbox v-model="configuration.allow_charge_is_amount" @change="calculateTotal"></el-checkbox>:</td>
                                        <td>{{ configuration.allow_charge_is_amount ? currency_type.symbol : '%' }}
                                            <!-- :disabled="config.active_allowance_charge == true ? true:false" -->

                                            <!-- v-model="total_global_charge" -->
                                            <el-input-number v-model="percentage_allowance_charge_user"
                                                             :min="0"
                                                             class="input-custom"
                                                             controls-position="right"
                                                             @change="calculateTotal"></el-input-number>
                                        </td>
                                    </tr>

                                    <tr v-if="form.items.length > 0">
                                        <td>
                                            <el-tooltip content="El redondeo debe ser un valor entre -0.99 y 0.99" effect="dark" placement="top-start">
                                                <i class="fa fa-info-circle"></i>
                                            </el-tooltip>
                                            Redondeo:</td>
                                        <td>{{ currency_type.symbol }}
                                            <el-input-number v-model="form.rounding" 
                                                :min="-0.99"
                                                :max="0.99"
                                                :step="0.01"
                                                class="input-custom"
                                                controls-position="right"
                                                @change="addRounding"
                                                @blur="checkRounding"></el-input-number>
                                        </td>
                                    </tr>

                                    <tr v-if="form.total > 0">
                                        <td><strong>TOTAL A PAGAR</strong>:</td>
                                        <td>{{ currency_type.symbol }} {{ form.total }}</td>
                                    </tr>

                                    <tr v-if="form.total > 0">
                                        <td>CONDICIÓN DE PAGO:</td>
                                        <td>
                                            <el-select v-model="form.payment_condition_id"
                                                       dusk="document_type_id"
                                                       popper-class="el-select-document_type"
                                                       style="max-width: 200px;"
                                                       @change="changePaymentCondition">
                                                <el-option label="Crédito con cuotas"
                                                           value="03"></el-option>
                                                <el-option label="Crédito"
                                                           value="02"></el-option>
                                                <el-option label="Contado"
                                                           value="01"></el-option>
                                            </el-select>
                                        </td>
                                    </tr>

                                    <!-- <template v-if="form.detraction">
                                        <tr v-if="form.detraction.amount > 0 && form.total_pending_payment > 0">
                                            <td width="60%">M. PENDIENTE:</td>
                                            <td>{{ currency_type.symbol }} {{ form.total_pending_payment }}</td>
                                        </tr>
                                    </template> -->

                                    <template v-if="form.detraction || form.retention">
                                        <tr v-if="has_pending_payment_base">
                                            <td>M. PENDIENTE:</td>
                                            <td>{{ currency_type.symbol }} 
                                                <el-input-number v-model="form.total_pending_payment" 
                                                                :min="0" 
                                                                :max="max_total_pending_payment"
                                                                :step="0.01"
                                                                :precision="2"
                                                                class="input-custom"
                                                                controls-position="right"
                                                                @change="changeTotalPendingPayment"
                                                                @blur="checkTotalPendingPayment"
                                                                :disabled="has_sale_note"
                                                                >
                                                            </el-input-number>
                                            </td>
                                        </tr>
                                    </template>

                                    <tr v-if="form.total > 0">
                                        <!-- Metodos de pago -->
                                        <td class="p-0"
                                            colspan="2">
                                            <!-- Crédito con cuotas -->
                                            <div v-if="form.payment_condition_id === '03'">
                                                <table
                                                       class="text-left"
                                                       width="100%">
                                                    <thead>
                                                    <tr v-if="form.fee.length > 0">
                                                        <th class="text-left"
                                                            style="width: 100px">Fecha
                                                            <el-tooltip content="Fecha del pago de las cuotas no puede ser anterior o el mismo día a la fecha de emisión del comprobante."
                                                                        placement="top">
                                                                <i class="fa fa-info-circle"></i>
                                                            </el-tooltip>
                                                        </th>
                                                        <th class="text-left"
                                                            style="width: 100px">Monto
                                                        </th>
                                                        <th style="width: 30px"></th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr v-for="(row, index) in form.fee"
                                                        :key="index">
                                                        <td>
                                                            <el-date-picker v-model="row.date"
                                                                            :clearable="false"
                                                                            format="dd/MM/yyyy"
                                                                            :picker-options="getMinDatePickerOptions(form.date_of_issue, 1)"
                                                                            type="date"
                                                                            @change="changeCreditFeeDate(index)"
                                                                            value-format="yyyy-MM-dd"></el-date-picker>
                                                        </td>
                                                        <td>
                                                            <el-input v-model="row.amount"></el-input>
                                                        </td>
                                                        <td class="text-center">
                                                            <button v-if="index > 0"
                                                                    class="btn waves-effect waves-light btn-xs btn-danger"
                                                                    type="button"
                                                                    @click.prevent="clickRemoveFee(index)">
                                                                <i class="fa fa-trash"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="5">
                                                            <label class="control-label">
                                                                <a class=""
                                                                   href="#"
                                                                   @click.prevent="clickAddFee"><i
                                                                    class="fa fa-plus font-weight-bold text-info"></i>
                                                                    <span
                                                                        style="color: #777777">Agregar cuota</span></a>

                                                            </label>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <!-- Credito -->
                                            <div v-if="form.payment_condition_id === '02'">
                                                <table v-if="form.fee.length>0"
                                                       class="text-left"
                                                       width="100%">
                                                    <thead>
                                                    <tr>
                                                        <th v-if="form.fee.length>0"
                                                            style="width: 120px">Método de pago
                                                        </th>
                                                        <th class="text-left"
                                                            style="width: 100px">Fecha
                                                        </th>
                                                        <th class="text-left"
                                                            style="width: 100px">Monto
                                                        </th>
                                                        <th style="width: 30px"></th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr v-for="(row, index) in form.fee"
                                                        :key="index">
                                                        <td>
                                                            <el-select
                                                                v-model="row.payment_method_type_id"
                                                                @change="changePaymentMethodType(index)">
                                                                <el-option
                                                                    v-for="option in credit_payment_metod"
                                                                    :key="option.id"
                                                                    :label="option.id"
                                                                    :value="option.id"
                                                                ></el-option>
                                                            </el-select>
                                                        </td>
                                                        <td>
                                                            <el-date-picker
                                                                v-model="row.date"
                                                                :clearable="false"
                                                                format="dd/MM/yyyy"
                                                                type="date"
                                                                value-format="yyyy-MM-dd"
                                                                :readonly="row.payment_method_type_id !== '09'">
                                                            </el-date-picker>
                                                        </td>
                                                        <td>
                                                            <el-input v-model="row.amount" :readonly="true"></el-input>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <!-- Contado -->
                                            <div v-if="!is_receivable && form.payment_condition_id === '01'" class="table-responsive payment">
                                                <table class="text-left">
                                                    <thead>
                                                    <tr>

                                                        <template v-if="showLoadVoucher && form.payments.length>0">
                                                            <th style="width:50px">Voucher</th>
                                                        </template>

                                                        <th v-if="form.payments.length>0"
                                                            style="width: 120px">Método de pago
                                                        </th>
                                                        <template v-if="enabled_payments">
                                                            <th v-if="form.payments.length>0"
                                                                style="width: 120px">Destino
                                                                <el-tooltip class="item"
                                                                            content="Aperture caja o cuentas bancarias"
                                                                            effect="dark"
                                                                            placement="top-start">
                                                                    <i class="fa fa-info-circle"></i>
                                                                </el-tooltip>
                                                            </th>
                                                            <th v-if="form.payments.length>0"
                                                                style="width: 100px">Referencia
                                                            </th>
                                                            <th v-if="form.payments.length>0"
                                                                style="width: 100px">Monto
                                                                <el-tooltip class="item"
                                                                    content="Cuando esta marcado se calcula el monto automáticamente"
                                                                    effect="dark"
                                                                    placement="top-start"
                                                                >
                                                                    <i class="fa fa-info-circle"></i>
                                                                </el-tooltip>
                                                                <br>
                                                                <el-checkbox label="Calcular monto"
                                                                    v-model="auto_calculate_amount"
                                                                ></el-checkbox>
                                                            </th>
                                                            <th style="width: 30px"></th>
                                                        </template>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr v-for="(row, index) in form.payments"
                                                        :key="index">

                                                        <template v-if="showLoadVoucher">
                                                            <td class="" style="width: 50px">
                                                                <!-- <el-tooltip class="item" content="Cargar voucher" effect="dark" placement="top-start"> -->
                                                                    <el-upload
                                                                        :data="{'index': index}"
                                                                        :headers="headers_token"
                                                                        :multiple="false"
                                                                        :on-remove="(file, fileList) => handleRemoveUploadVoucher(file, fileList, index)"
                                                                        :action="`/finances/payment-file/upload`"
                                                                        :show-file-list="true"
                                                                        :file-list="row.file_list"
                                                                        :on-success="(response, file, fileList) => onSuccessUploadVoucher(response, file, fileList, index)"
                                                                        :limit="1"
                                                                        >
                                                                            <button  type="button" class="btn btn-sm btn-primary"  slot="trigger">
                                                                                <i class="fas fa-fw fa-upload"></i>
                                                                            </button>
                                                                    </el-upload>
                                                                <!-- </el-tooltip> -->
                                                            </td>
                                                        </template>

                                                        <td>
                                                            <el-select
                                                                v-model="row.payment_method_type_id"
                                                                @change="changePaymentMethodType(index)">
                                                                <el-option
                                                                    v-for="option in cash_payment_metod"
                                                                    :key="option.id"
                                                                    :label="option.description"
                                                                    :value="option.id"></el-option>
                                                            </el-select>
                                                        </td>
                                                        <template v-if="enabled_payments">
                                                            <td>
                                                                <el-select v-model="row.payment_destination_id"
                                                                           filterable>
                                                                    <el-option v-for="option in payment_destinations"
                                                                               :key="option.id"
                                                                               :label="option.description"
                                                                               :value="option.id"></el-option>
                                                                </el-select>
                                                            </td>
                                                            <td>
                                                                <el-input v-model="row.reference"></el-input>
                                                            </td>
                                                            <td>
                                                                <el-input v-model="row.payment"
                                                                    @blur="recalculateTotalForPayment(index)"
                                                                ></el-input>
                                                            </td>
                                                            <td class="text-center">
                                                                <button
                                                                    class="btn waves-effect waves-light btn-xs btn-danger"
                                                                    type="button"
                                                                    @click.prevent="clickCancel(index)">
                                                                    <i class="fa fa-trash"></i>
                                                                </button>
                                                            </td>
                                                        </template>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="5">
                                                            <label class="control-label">
                                                                <a class=""
                                                                   href="#"
                                                                   @click.prevent="clickAddPayment"><i
                                                                    class="fa fa-plus font-weight-bold text-info"></i>
                                                                    <span style="color: #777777">Agregar pago</span></a>

                                                            </label>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </td>
                                    </tr>

                                </table>
                            </div>

                        </div>
                        <!-- @todo: Mejorar evitando duplicar codigo -->
                        <!-- Mostrar en cel -->
                    </div>
                    <!-- @todo: Mejorar evitando duplicar codigo -->
                    <!-- Ocultar en cel -->
                    <div class="card-footer text-right  hidden-sm-down">
                        <button
                            class="btn btn-success"
                            style="min-width: 180px"
                            v-if="form.items.length > 0 && this.dateValid"
                            @click.prevent="openDialogPreview()">
                            Vista Previa
                        </button>
                        <button class="btn btn-default"
                                style="min-width: 180px"
                                @click.prevent="close()">Cancelar
                        </button>
                        <el-popover
                            placement="top-start"
                            :open-delay="1000"
                            width="145"
                            trigger="hover"
                            content="Presiona ALT + G">
                            <el-button slot="reference"
                                       v-if="form.items.length > 0 && this.dateValid"
                                       :loading="loading_submit"
                                       class="submit btn btn-primary"
                                       native-type="submit"
                                       style="min-width: 180px">
                                {{ btnText }} <kbd>ALT</kbd>+<kbd>G</kbd>
                            </el-button>
                        </el-popover>
                    </div>
                    <!-- @todo: Mejorar evitando duplicar codigo -->
                    <!-- Ocultar en cel -->

                    <!-- @todo: Mejorar evitando duplicar codigo -->
                    <!-- Mostrar en cel -->
                    <div class="card-footer   hidden-md-up ">
                        <div class="col-12 row text-center">
                            <div class="col-4 text-center px-1">
                                <button
                                    class="btn btn-success form-control"
                                    v-if="form.items.length > 0 && this.dateValid"
                                    @click.prevent="openDialogPreview()">
                                    Vista Previa
                                </button>
                            </div>
                            <div class="col-4 text-center">
                                <button
                                    class="btn btn-default form-control"
                                    @click.prevent="close()">Cancelar
                                </button>
                            </div>
                            <div class="col-4 text-center">

                                <el-button v-if="form.items.length > 0 && this.dateValid"
                                           :loading="loading_submit"
                                           class="submit btn btn-primary form-control"
                                           native-type="submit"
                                >{{ btnText }}
                                </el-button>
                            </div>
                        </div>
                    </div>
                    <!-- Mostrar en cel -->
                    <!-- @todo: Mejorar evitando duplicar codigo -->

                </div>
            </form>
        </div>

        <document-report-customer
            :showDialog.sync="showDialogReportCustomer"
            :customerId="report_to_customer_id"></document-report-customer>

        <document-form-item
            :configuration="config"
            :currency-type-id-active="form.currency_type_id"
            :documentId="documentId"
            :editNameProduct="config.edit_name_product"
            :exchange-rate-sale="form.exchange_rate_sale"
            :isEditItemNote="false"
            :operation-type-id="form.operation_type_id"
            :recordItem="recordItem"
            :showDialog.sync="showDialogAddItem"
            :typeUser="typeUser"
            :customer-id="form.customer_id"
            :currency-types="currency_types"
            :is-from-invoice="true"
            :percentage-igv="percentage_igv"
            :isUpdateDocument="isUpdateDocument"
            :permissionEditItemPrices="authUser.permission_edit_item_prices"
            ref="form_add_item"
            :selectedOptionPrice="selected_option_price"
            @add="addRow"></document-form-item>

        <person-form :document_type_id=form.document_type_id
                     :external="true"
                     :input_person="input_person"
                     :showDialog.sync="showDialogNewPerson"
                     type="customers"></person-form>

        <document-options :configuration="config"
                          :isContingency="is_contingency"
                          :isUpdate="isUpdate"
                          :recordId="documentNewId"
                          :table="table"
                          :showClose="false"
                          :showDialog.sync="showDialogOptions"></document-options>


        <document-hotel-form
            :hotel="form.hotel"
            :showDialog.sync="showDialogFormHotel"
            @addDocumentHotel="addDocumentHotel"
            ref="formRef"
        ></document-hotel-form>

        <document-transport-form
            :showDialog.sync="showDialogFormTransport"
            :transport="form.transport"
            @addDocumentTransport="addDocumentTransport"
        ></document-transport-form>

        <document-detraction
            :currency-type-id-active="form.currency_type_id"
            :detraction="form.detraction"
            :exchange-rate-sale="form.exchange_rate_sale"
            :operation-type-id="form.operation_type_id"
            :showDialog.sync="showDialogDocumentDetraction"
            :total="form.total"
            :isUpdateDocument="isUpdateDocument"
            :detractionDecimalQuantity="detractionDecimalQuantity"
            :configuration="config"
            @addDocumentDetraction="addDocumentDetraction"></document-detraction>

        <document-service-country :showDialog.sync="showDialogServiceCountry" :countries="countries" :service-country-id="form.service_country_id" @addServiceCountry="addServiceCountry"></document-service-country>
        <store-item-series-index :show-dialog.sync="showDialogItemSeriesIndex"
                                 :item="recordItem"
                                 :document-id="documentId"
                                 @success="successItemSeries"></store-item-series-index>

        <document-form-preview
            :showDialog.sync="showDialogPreview"
            :preview="preview">
        </document-form-preview>


        <!-- <item-detail-form
            :recordId="itemDetailId"
            :showDialog.sync="showDialogItemDetail"
            :onlyShowAllDetails="configuration.show_all_item_details"
        >
        </item-detail-form> -->

    </div>
</template>

<style>
.input-custom {
    width: 50% !important;
}

.el-textarea__inner {
    height: 65px !important;
    min-height: 65px !important;
}

.card-header + .card-body {
    border-radius: 0px;
}

.card-body {
    border-radius: 0px;
}

.el-collapse-item__content {
    padding-bottom: 0px;
}

.content-body {
    padding: 20px;
}

.el-upload-list__item{
    max-width: 100px;
}
</style>
<script>
import DocumentFormItem from './partials/item.vue'
import PersonForm from '../persons/form.vue'
import DocumentOptions from '../documents/partials/options.vue'
import {exchangeRate, functions, pointSystemFunctions, fnRestrictSaleItemsCpe, fnItemSearchQuickSale} from '../../../mixins/functions'
import {calculateRowItem, showNamePdfOfDescription} from '../../../helpers/functions'
import Logo from '../companies/logo.vue'
import DocumentHotelForm from '../../../../../modules/BusinessTurn/Resources/assets/js/views/hotels/form.vue'
import DocumentTransportForm from '../../../../../modules/BusinessTurn/Resources/assets/js/views/transports/form.vue'
import DocumentDetraction from './partials/detraction.vue'
import moment from 'moment'
import {mapActions, mapState} from "vuex/dist/vuex.mjs";
import Keypress from "vue-keypress";
import StoreItemSeriesIndex from "../Store/ItemSeriesIndex";
import DocumentReportCustomer from './partials/report_customer.vue'
import SetTip from '@components/SetTip.vue'
import DocumentServiceCountry from './partials/service_country.vue'
import LotsForm from './partials/lots.vue'
import { editableRowItems } from '@mixins/editable-row-items'
import ItemSearchQuickSale from '@components/items/ItemSearchQuickSale.vue'
import PackItemDescription from '@components/items/PackItemDescription.vue'
// import ItemDetailForm from '@views/items/form.vue'
import DocumentFormPreview from './partials/preview.vue'


export default {
    props: [
        'idUser',
        'typeUser',
        'configuration',
        'documentId',
        'table',
        'tableId',
        'isUpdate',
        'authUser',
    ],
    components: {
        StoreItemSeriesIndex,
        DocumentFormItem,
        PersonForm,
        DocumentOptions,
        Logo,
        DocumentHotelForm,
        Keypress,
        DocumentDetraction,
        DocumentTransportForm,
        DocumentReportCustomer,
        SetTip,
        LotsForm,
        ItemSearchQuickSale,
        // ItemDetailForm,
        PackItemDescription,
        DocumentFormPreview,
        DocumentServiceCountry
    },
    mixins: [functions, exchangeRate, pointSystemFunctions, fnRestrictSaleItemsCpe, editableRowItems, fnItemSearchQuickSale],
    data() {
        return {
            auto_calculate_amount: true,
            total_pending_payment_edited: false, // true cuando el usuario edita M. PENDIENTE a mano
            // pickerMinDate: {
            //     disabledDate(time) {
            //         const minDate = moment().add(1, 'days').startOf('day'); // mañana a las 00:00
            //         return time.getTime() < minDate.valueOf()
            //     }
            // },
            datEmision: {
                disabledDate(time) {
                    return time.getTime() > moment();
                }
            },
            multiple: [
                {
                    keyCode: 78, // N
                    modifiers: ['altKey'],
                    preventDefault: true,
                },
                {
                    keyCode: 71, // g
                    modifiers: ['altKey'],
                    preventDefault: true,
                },
            ],
            // default_document_type: null,
            // default_series_type: null,
            countries: [],
            showDialogServiceCountry: false,
            focus_on_client: false,
            dateValid: false,
            input_person: {},
            showDialogDocumentDetraction: false,
            has_data_detraction: false,
            showDialogFormHotel: false,
            showDialogFormTransport: false,
            showDialogItemSeriesIndex: false,
            is_client: false,
            recordItem: null,
            resource: 'documents',
            showDialogAddItem: false,
            showDialogNewPerson: false,
            showDialogOptions: false,
            loading_submit: false,
            loading_form: false,
            errors: {},
            form: {},
            document_types: [],
            currency_types: [],
            discount_types: [],
            charges_types: [],
            all_customers: [],
            business_turns: [],
            form_payment: {},
            document_types_guide: [],
            customers: [],
            sellers: [],
            company: null,
            document_type_03_filter: null,
            operation_types: [],
            establishments: [],
            payment_method_types: [],
            establishment: null,
            // all_series: [],
            // series: [],
            prepayment_documents: [],
            currency_type: {},
            documentNewId: null,
            prepayment_deduction: false,
            activePanel: 0,
            total_global_discount: 0,
            total_global_charge: 0,
            loading_search: false,
            is_amount: true,
            enabled_discount_global: false,
            user: null,
            is_receivable: false,
            is_contingency: false,
            cat_payment_method_types: [],
            select_first_document_type_03: false,
            detraction_types: [],
            all_detraction_types: [],
            customer_addresses: [],
            payment_destinations: [],
            form_cash_document: {},
            enabled_payments: true,
            readonly_date_of_due: false,
            seller_class: 'col-lg-6 pb-2',
            btnText: 'Generar',
            payment_conditions: [],
            affectation_igv_types: [],
            total_discount_no_base: 0,
            global_discount_non_taxed: 0,
            show_has_retention: true,
            global_discount_types: [],
            global_discount_type: {},
            error_global_discount: false,
            headers_token: headers_token,
            showDialogReportCustomer: false,
            report_to_customer_id: null,
            retention_query_data: null,
            
            selected_option_price: null,
            price_options: [
                {
                    id: 1,
                    description: 'Precio principal',
                },
                {
                    id: 'price1',
                    description: 'Precio 1',
                },
                {
                    id: 'price2',
                    description: 'Precio 2',
                },
                {
                    id: 'price3',
                    description: 'Precio 3'
                }
            ],
            showDialogPreview: false,

            monto_pagar_sin_dcto: 0,
            monto_pagar_sin_dcto_sale_note: 0,
            percentage_allowance_charge_: 0,
            percentage_allowance_charge_user: 0,
            total_original: 0,
            has_sale_note: false,
            from_sale_note: false,
            show_terms_and_conditions: false
        }
    },
    computed: {
        isGeneratedFromExternal()
        {
            return (this.table != undefined && this.table) && (this.tableId != undefined && this.tableId)
        },
        showLoadVoucher()
        {
            return this.configuration.show_load_voucher && !this.isUpdateDocument
        },
        isGlobalDiscountBase: function () {
            return (this.configuration.global_discount_type_id === '02')
        },
        ...mapState([
            'config',
            'series',
            'all_series',
        ]),
        credit_payment_metod: function () {
            return _.filter(this.payment_method_types, {'is_credit': true})
        },
        cash_payment_metod: function () {
            return _.filter(this.payment_method_types, {'is_credit': false})
        },
        existDiscountsNoBase: function () {
            return this.total_discount_no_base > 0 ? true : false
        },
        isUpdateDocument: function () {
            return (this.documentId) ? true : false
        },
        isCreditPaymentCondition: function () {
            return ['02', '03'].includes(this.form.payment_condition_id)
        },
        detractionDecimalQuantity: function () {
            return (this.configuration.detraction_amount_rounded_int) ? 0 : 2
        },
        isAutoPrint: function () {

            if (this.configuration) {
                return this.configuration.auto_print
            }

            return false
        },
        hidePreviewPdf: function () {

            if (this.configuration) {
                return this.configuration.hide_pdf_view_documents
            }

            return false
        },
        isFromExternalDocument()
        {
            return (this.table !== undefined && this.table !== null)
        },
        canAddDescriptionToDocumentItem()
        {
            if (this.configuration) return this.configuration.add_description_to_document_item

            return false
        },

        totalDiscountOnlyVisual() {
            const discount_per_items = this.form.items.reduce((total, item) => {
                let discounts = item.discounts

                // puede llegar como objeto indexado {0:{...},1:{...}} desde la BD
                if (discounts && !Array.isArray(discounts) && typeof discounts === 'object') {
                    discounts = Object.values(discounts)
                }

                const sumDiscounts = (discounts && Array.isArray(discounts))
                    ? discounts.reduce((sum, discount) => sum + (Number(discount.amount) || 0), 0)
                    : 0

                return total + sumDiscounts
            }, 0)

            let global_discount = 0
            let aux_global_discount = Number(this.total_global_discount) || 0

            if (!this.is_amount) {
                global_discount = _.round(this.total_original * (aux_global_discount / 100), 2)
            } else {
                global_discount = aux_global_discount
            }

            const total_discounts = _.round(discount_per_items + global_discount, 2)

            this.form.dcto_totales_input = total_discounts

            return total_discounts
        },
        // Bases onerosas por tipo, con el MISMO criterio que usa discountGlobal
        // para armar nonTaxedBase (afectación 20/30, valor sin redondeo).
        nonTaxedOnerousByType() {
            let exonerated = 0
            let unaffected = 0

            this.form.items.forEach(row => {
                const id = String(row.affectation_igv_type_id)
                if (id !== '20' && id !== '30') return

                const raw = row.total_value_without_rounding
                const value = (raw !== null && raw !== undefined)
                    ? Number(raw)
                    : Number(row.total_value)

                if (!Number.isFinite(value)) return

                if (id === '20') exonerated += value
                else unaffected += value
            })

            return {
                exonerated: _.round(exonerated, 2),
                unaffected: _.round(unaffected, 2),
            }
        },

        totalExoneratedOnlyVisual() {
            const exonerated = Number(this.form.total_exonerated) || 0
            const discount = Number(this.global_discount_non_taxed) || 0
            const bases = this.nonTaxedOnerousByType
            const base = _.round(bases.exonerated + bases.unaffected, 2)

            if (discount <= 0 || base <= 0) return _.round(exonerated, 2)

            const share = _.round(discount * (bases.exonerated / base), 2)

            return _.round(exonerated - share, 2)
        },

        totalUnaffectedOnlyVisual() {
        // Calculo de distribución del descuento para OP. GRAVADA, EXONERADA e INAFECTA PROPORCIONALMENTE
        // En caso que sea un descuento que no afecte a la base imponible (CODIGO 03) se mostrara el IMPORTE menos el descuento proporcional
        // Ejemplo: si el descuento afecta a un monto exonerado de 10 soles y el descuento proporcional es de -0.20 se mostrara 10 - 0.20 = 9.80
        // Este ejemplo se mostrara de igual manera en el formulario para generar un comprobante y en el PDF
        // Pero en el reporte contable se mostrara 10 soles en exonerado en la columna Operación exonerada y 
        // -0.20 se mostrara en la columna otros tributos
            const unaffected = Number(this.form.total_unaffected) || 0
            const discount = Number(this.global_discount_non_taxed) || 0
            const bases = this.nonTaxedOnerousByType
            const base = _.round(bases.exonerated + bases.unaffected, 2)

            if (discount <= 0 || base <= 0) return _.round(unaffected, 2)

            // el residuo de centavos se asigna aquí para que
            // (share exonerada + share inafecta) === global_discount_non_taxed
            const exonerated_share = _.round(discount * (bases.exonerated / base), 2)
            const share = _.round(discount - exonerated_share, 2)

            return _.round(unaffected - share, 2)
        },


        exceeds700() {
            const customer = this.customers.find(customer => customer.id === this.form.customer_id)
            //return this.form.document_type_id === '03' && this.form.total > 90000 && customer && customer.identity_document_type_id === '0'
            return false
        },
        max_total_pending_payment() {
            let total = parseFloat(this.form.total) || 0
            if (this.form.has_retention && this.form.retention && this.form.retention.amount) {
                total = _.round(total - (parseFloat(this.form.retention.amount) || 0), 2)
            }
            return total > 0 ? total : 0
        },
        has_pending_payment_base() {
            const total = parseFloat(this.form.total) || 0
            const pending = parseFloat(this.form.total_pending_payment) || 0
            const has_base = !_.isEmpty(this.form.detraction) || !_.isEmpty(this.form.retention)

            return has_base && total > 0 && (pending > 0 || this.total_pending_payment_edited)
        },
    },

    watch: {
        'form.items': function (items) {
            if (items.length === 0) {
                this.form.dcto_totales_input = 0
                this.form.rounding = 0
            }
        },

        'form.rounding': function (rounding) {
            let rounding_ = parseFloat(rounding) || 0
            // if (rounding_ === 0) {
            //     this.calculateTotal()
            // } else {
            //     this.calculateTotal()
            //     this.form.total = (parseFloat(this.form.total) + rounding).toFixed(2)
            // }
            this.calculateTotal()
            this.calculatePayments()
        }
    },

    mounted() {
        if (this.config.active_allowance_charge) {
            this.percentage_allowance_charge_ = parseFloat(this.config.percentage_allowance_charge)
            this.total_global_charge = this.percentage_allowance_charge_
            this.percentage_allowance_charge_user = this.percentage_allowance_charge_
        }
    },

    async created() {
        const clientfromDispatchesOrNotes = localStorage.getItem('client');
        this.selected_option_price = this.price_options[0].id;
        // console.log(this.$store.state.all_series)
        this.loadConfiguration()
        this.$store.commit('setConfiguration', this.configuration)
        await this.initForm()
        await this.$http.get(`/${this.resource}/tables`)
            .then(response => {
                this.document_types = response.data.document_types_invoice;
                this.document_types_guide = response.data.document_types_guide;
                this.currency_types = response.data.currency_types
                this.business_turns = response.data.business_turns
                this.establishments = response.data.establishments
                this.operation_types = response.data.operation_types
                this.$store.commit('setAllSeries', response.data.series)
                // this.all_series = response.data.series
                this.countries = response.data.countries
                this.all_customers = response.data.customers
                this.sellers = response.data.sellers
                this.discount_types = response.data.discount_types
                this.charges_types = response.data.charges_types
                this.payment_method_types = response.data.payment_method_types
                this.enabled_discount_global = response.data.enabled_discount_global
                this.company = response.data.company;
                this.user = response.data.user;
                this.document_type_03_filter = response.data.document_type_03_filter;
                this.select_first_document_type_03 = response.data.select_first_document_type_03
                // this.form.currency_type_id = (this.currency_types.length > 0)?this.currency_types[0].id:null;
                this.form.establishment_id = (this.establishments.length > 0) ? this.establishments[0].id : null;
                this.form.document_type_id = (this.document_types.length > 0) ? this.document_types[0].id : null;
                this.form.operation_type_id = (this.operation_types.length > 0) ? this.operation_types[0].id : null;
                this.form.seller_id = (this.sellers.length > 0) ? this.idUser : null;
                this.affectation_igv_types = response.data.affectation_igv_types
                // this.prepayment_documents = response.data.prepayment_documents;
                this.is_client = response.data.is_client;
                // this.cat_payment_method_types = response.data.cat_payment_method_types;
                // this.all_detraction_types = response.data.detraction_types;
                this.payment_destinations = response.data.payment_destinations
                this.payment_conditions = response.data.payment_conditions;

                this.seller_class = (this.user == 'admin') ? 'col-lg-4 pb-2' : 'col-lg-6 pb-2';
                this.global_discount_types = response.data.global_discount_types
                this.show_terms_and_conditions = response.data.show_terms_and_conditions
                // this.default_document_type = response.data.document_id;
                // this.default_series_type = response.data.series_id;
                this.clickAddPayment()
                this.selectDocumentType()
                if (!clientfromDispatchesOrNotes) {
                    this.changeEstablishment()
                }
                this.changeDateOfIssue()
                this.changeDocumentType()
                this.changeDestinationSale()
                this.changeCurrencyType()
                this.setDefaultDocumentType();
                this.setConfigGlobalDiscountType()
            })
        await this.getPercentageIgv();
        this.loading_form = true
        this.$eventHub.$on('reloadDataPersons', (customer_id) => {
            this.reloadDataCustomers(customer_id)
        })
        this.$eventHub.$on('initInputPerson', () => {
            this.initInputPerson()
        });
        if (this.documentId) {
            this.btnText = 'Actualizar';
            this.loading_submit = true;
            await this.$http.get(`/documents/${this.documentId}/show`).then(response => {
                this.onSetFormData(response.data.data);
            }).finally(() => this.loading_submit = false);
        }

        /*
         * #830
         */
        if (this.table) {
            await this.$http.get(`/store/record/${this.table}/${this.tableId}`)
                .then(response => {
                    console.log('response')
                    console.log(response.data.data)
                    this.onSetFormData(response.data.data);
                })
                .finally(() => this.loading_submit = false);
        }
        /*
         * #830
         */

        const itemsFromDispatches = localStorage.getItem('items');
        if (itemsFromDispatches) {
            const itemsParsed = JSON.parse(itemsFromDispatches);
            const items = itemsParsed.map(i => i.item_id);
            const params = {
                items_id: items
            }
            localStorage.removeItem('items');
            await this.$http.get('/documents/search-items', {params}).then(response => {
                const itemsResponse = response.data.items.map(i => {
                    return this.setItemFromResponse(i, itemsParsed, true);
                });
                this.form.items = itemsResponse.map(i => {
                    return calculateRowItem(i, this.form.currency_type_id, this.form.exchange_rate_sale, this.percentage_igv)
                });
            });
        }

        const itemsFromNotes = localStorage.getItem('itemsForNotes');
        if (itemsFromNotes) {
            const itemsParsed = JSON.parse(itemsFromNotes);
            const items = itemsParsed.map(i => i.id);
            const params = {
                items_id: items
            }
            localStorage.removeItem('itemsForNotes');
            await this.$http.get('/documents/search-items', {params}).then(response => {
                const itemsResponse = response.data.items.map(i => {
                    return this.setItemFromResponse(i, itemsParsed);
                });
                this.form.items = itemsResponse.map(i => {
                    return calculateRowItem(i, this.form.currency_type_id, this.form.exchange_rate_sale, this.percentage_igv)
                });
            });
        }

        //parse items from multiple sale notes not group
        await this.processItemsForNotesNotGroup()

        const lotsItems = localStorage.getItem('lotsItems');
        if (lotsItems) {
            const lotsParsed = JSON.parse(lotsItems);
            localStorage.removeItem('lotsItems');
            this.form.items = this.form.items.map(row => {
                row.item.lots = _.filter(lotsParsed, {'item_id': row.item_id});
                return row;
            });
        }

        // const clientfromDispatchesOrNotes = localStorage.getItem('client');
        if (clientfromDispatchesOrNotes) {
            const client = JSON.parse(clientfromDispatchesOrNotes);
            if (client.identity_document_type_id == 1 || client.identity_document_type_id == 0) {
                this.form.document_type_id = '03'
            } else if (client.identity_document_type_id == 6) {
                this.form.document_type_id = '01'
            }
            this.searchRemoteCustomers(client.number);
            this.form.customer_id = client.id;
            this.form.customer_address_id = client.address_id
            await this.prepareDataCustomer(true)
            await this.changeEstablishment(client.number);
            this.filterSeries();
            this.filterCustomers();
            this.changeCurrencyType()
            localStorage.removeItem('client');
        }
        const dispatchesNumbersFromDispatches = localStorage.getItem('dispatches');
        if (dispatchesNumbersFromDispatches) {
            this.form.dispatches_relateds = JSON.parse(dispatchesNumbersFromDispatches);
            localStorage.removeItem('dispatches')
        }
        const notesNumbersFromNotes = localStorage.getItem('notes');
        if (notesNumbersFromNotes) {
            // this.form.sale_notes_relateds = JSON.parse(notesNumbersFromNotes);
            const notes = JSON.parse(notesNumbersFromNotes)
            this.form.sale_notes_relateds = notes
            this.has_sale_note = true
            this.form.sale_note_id = notes.id
            localStorage.removeItem('notes')
        }

        const moreDataFromSaleNotes = localStorage.getItem('more_data')
        if (moreDataFromSaleNotes) {
            const moreData = JSON.parse(moreDataFromSaleNotes)
            this.total_original = parseFloat(moreData.monto_pagar_sin_dcto) || 0
            this.monto_pagar_sin_dcto_sale_note = parseFloat(moreData.monto_pagar_sin_dcto) || 0
            this.monto_pagar_sin_dcto = this.monto_pagar_sin_dcto_sale_note
            this.total_global_discount = parseFloat(moreData.dcto_monto_input) || 0
            this.form.rounding = parseFloat(moreData.rounding) || 0
            this.percentage_allowance_charge_user = parseFloat(moreData.total_charge) || 0
            this.is_amount = moreData.global_discount_as_percentage ? false : true
            // this.total_global_discount = parseFloat(moreData.monto_pagar_sin_dcto) || 0
            // this.total_global_discount = parseFloat(moreData.dcto_totales_input) || 0

            this.form.plate_number = moreData.plate_number || null
            this.form.additional_information = moreData.observation || null
            this.form.purchase_order = moreData.purchase_order || null
            localStorage.removeItem('more_data')
            
            this.changeCurrencyType()
        }

        this.startConnectionQzTray()

    },
    methods: {
        getMinDatePickerOptions(base, add = 0) {
            const minDate = moment(base, 'YYYY-MM-DD').add(add, 'days').startOf('day')
            return {
                disabledDate(time) {
                    return time.getTime() < minDate.valueOf()
                }
            }
        },
        addRounding() {
            // let rounding = parseFloat(this.form.rounding) || 0
            // this.form.total = (parseFloat(this.form.total) + rounding).toFixed(2)
        },

        checkRounding() {
            if (this.form.rounding == '') {
                this.form.rounding = 0
            }
        },

        valueInputSelect(event)
        {
           event.target.select()
        },
        clickShowItemDetail(id)
        {
            // this.itemDetailId = id
            // this.showDialogItemDetail = true
            window.open(`/items/show-item-detail/${id}`)
        },
        changeDataTip(tip)
        {
            if(tip)
            {
                this.form.worker_full_name_tips = tip.worker_full_name_tips
                this.form.total_tips = tip.total_tips
            }
        },
        onSuccessUploadVoucher(response, file, fileList, index)
        {
            if (response.success)
            {
                this.form.payments[index].filename = response.data.filename
                this.form.payments[index].temp_path = response.data.temp_path
                this.form.payments[index].file_list = fileList
            }
            else
            {
                this.cleanFileListUploadVoucher(index)
                this.$message.error(response.message)
            }

        },
        cleanFileListUploadVoucher(index)
        {
            this.form.payments[index].file_list = []
        },
        handleRemoveUploadVoucher(file, fileList, index)
        {
            this.form.payments[index].filename = null
            this.form.payments[index].temp_path = null
            this.cleanFileListUploadVoucher(index)
        },
        ...mapActions([
            'loadConfiguration',
        ]),
        initForm() {
            this.errors = {}
            this.form = {
                establishment_id: null,
                document_type_id: null,
                series_id: null,
                seller_id: this.idUser,
                number: '#',
                date_of_issue: moment().format('YYYY-MM-DD'),
                time_of_issue: moment().format('HH:mm:ss'),
                customer_id: null,
                currency_type_id: this.config.currency_type_id,
                purchase_order: null,
                exchange_rate_sale: 0,
                total_prepayment: 0,
                total_charge: 0,
                total_discount: 0,
                total_exportation: 0,
                total_free: 0,
                total_taxed: 0,
                total_unaffected: 0,
                total_exonerated: 0,
                total_igv: 0,
                total_base_isc: 0,
                total_isc: 0,
                total_base_other_taxes: 0,
                total_other_taxes: 0,
                total_plastic_bag_taxes: 0,
                total_taxes: 0,
                total_value: 0,
                total: 0,
                subtotal: 0,
                total_igv_free: 0,
                operation_type_id: null,
                date_of_due: moment().format('YYYY-MM-DD'),
                items: [],
                charges: [],
                discounts: [],
                attributes: [],
                guides: [],
                service_country_id: null,
                payments: [],
                prepayments: [],
                legends: [],
                detraction: {},
                additional_information: null,
                plate_number: null,
                has_prepayment: false,
                affectation_type_prepayment: null,
                actions: {
                    format_pdf: 'a4',
                },
                hotel: {},
                transport: {},
                customer_address_id: null,
                pending_amount_prepayment: 0,
                payment_method_type_id: null,
                show_terms_condition: true,
                terms_condition: '',
                payment_condition_id: '01',
                fee: [],
                total_pending_payment: 0,
                has_retention: false,
                retention: {},
                quotation_id: null,
                
                worker_full_name_tips: null, //propinas
                total_tips: 0, //propinas

                type_device: 'web',

                dcto_monto_input: 0,
                dcto_totales_input: 0,
                monto_pagar_sin_dcto: 0,
                rounding: 0,
                sale_note_id: null,
                has_sale_note: false,
                source_module: 'Venta tradicional',
            }

            this.form_cash_document = {
                document_id: null,
                sale_note_id: null,

                cash_id: null
            }

            // this.clickAddPayment()
            this.clickAddInitGuides()
            this.is_receivable = false
            this.total_global_discount = 0
            this.total_global_charge = 0
            this.is_amount = true
            this.prepayment_deduction = false
            this.imageDetraction = {}
            this.$eventHub.$emit('eventInitForm')

            this.initInputPerson()

            if (!this.config.restrict_receipt_date) {
                this.datEmision = {}
            }
            this.total_pending_payment_edited = false
            this.enabled_payments = true
            this.readonly_date_of_due = false
            this.total_discount_no_base = 0
            this.global_discount_non_taxed = 0
            this.calculate_customer_accumulated_points = 0
            this.total_exchange_points = 0

            this.retention_query_data = null

            this.percentage_allowance_charge_user = 0

            this.$eventHub.$emit('eventInitTip')

        },
        startConnectionQzTray() {

            if (!qz.websocket.isActive() && this.isAutoPrint) {
                startConnection();
            }

        },
        changeRowExchangePoints(row, index)
        {
            row.item.change_free_affectation_igv = !row.item.change_free_affectation_igv
            row.item.used_points_for_exchange = row.item.change_free_affectation_igv ? this.getUsedPoints(row) : null
            this.setTotalExchangePoints() //in mixins
            this.changeRowFreeAffectationIgv(row, index)
        },
        async changeRowFreeAffectationIgv(row, index) {

            if (row.item.change_free_affectation_igv) {

                this.form.items[index].affectation_igv_type_id = '15'
                this.form.items[index].affectation_igv_type = await _.find(this.affectation_igv_types, {id: this.form.items[index].affectation_igv_type_id})

            } else {

                this.form.items[index].affectation_igv_type_id = this.form.items[index].item.original_affectation_igv_type_id
                this.form.items[index].affectation_igv_type = await _.find(this.affectation_igv_types, {id: this.form.items[index].affectation_igv_type_id})
            }

            this.form.items[index] = await calculateRowItem(row, this.form.currency_type_id, this.form.exchange_rate_sale, this.percentage_igv)
            await this.calculateTotal()

        },
        async processItemsForNotesNotGroup() {

            let itemsNotGroupForNotes = localStorage.getItem('itemsNotGroupForNotes')

            if (itemsNotGroupForNotes) {
                this.from_sale_note = true

                let itemsParsed = JSON.parse(itemsNotGroupForNotes)

                // prepare - validate prop presentation and others
                // this.form.items = await this.onPrepareItems(itemsParsed).map(element => {
                //     element.item.presentation = element.item.presentation ? element.item.presentation : []
                //     return element
                // });


                // LOG DESPUÉS del console.log del objeto


                this.form.items = itemsParsed.map(element => {
                    // Convertir discounts de objeto a array
                    element.discounts = element.discounts ? Object.values(element.discounts) : []
                    element.charges = element.charges || []
                    // element.attributes = element.attributes || []
                    element.attributes = Array.isArray(element.attributes) ? element.attributes
                                        : (element.attributes ? Object.values(element.attributes) : [])
                    element.item.presentation = element.item.presentation ? element.item.presentation : []
                    
                    // Agregar propiedades necesarias sin alterar valores
                    element.unit_price_value = element.unit_value
                    element.input_unit_price_value = element.unit_price

                    element.total_original = parseFloat(
                        (parseFloat(element.quantity) * parseFloat(element.unit_price)).toFixed(2)
                    )
                    return element
                })

                // await this.calculateTotal()
                localStorage.removeItem('itemsNotGroupForNotes');
            }

        },
        setItemFromResponse(item, itemsParsed, sum_quantity = false)
        {
            /* Obtiene el igv del item, si no existe, coloca el gravado*/
            if (item.sale_affectation_igv_type !== undefined) {
                item.affectation_igv_type = item.sale_affectation_igv_type
            } else {
                item.affectation_igv_type = {
                    active: 1,
                    description: "Gravado - Operación Onerosa",
                    exportation: 0,
                    free: 0,
                    id: "10",
                }
            }
            item.presentation = {};

            item.item = {
                amount_plastic_bag_taxes: item.amount_plastic_bag_taxes,
                attributes: item.attributes,
                brand: item.brand,
                calculate_quantity: item.calculate_quantity,
                category: item.category,
                currency_type_id: item.currency_type_id,
                currency_type_symbol: item.currency_type_symbol,
                description: item.description,
                full_description: item.full_description,
                has_igv: item.has_igv,
                has_plastic_bag_taxes: item.has_plastic_bag_taxes,
                id: item.id,
                internal_id: item.internal_id,
                item_unit_types: item.item_unit_types,
                lots: item.lots,
                lots_enabled: item.lots_enabled,
                lots_group: item.lots_group,
                model: item.model,
                presentation: {},
                purchase_affectation_igv_type_id: item.purchase_affectation_igv_type_id,
                purchase_unit_price: item.purchase_unit_price,
                sale_affectation_igv_type_id: item.sale_affectation_igv_type_id,
                sale_unit_price: item.sale_unit_price,
                series_enabled: item.series_enabled,
                stock: item.stock,
                unit_price: item.sale_unit_price,
                unit_type_id: item.unit_type_id,
                warehouses: item.warehouses,
            };
            item.IdLoteSelected = null;
            if (item.affectation_igv_type_id === undefined) {
                item.affectation_igv_type_id = item.affectation_igv_type.id;
                // item.affectation_igv_type_id = "10";
            }
            item.discounts = [];
            item.charges = [];
            item.item_id = item.id;
            item.unit_price_value = item.sale_unit_price;
            item.input_unit_price_value = item.sale_unit_price;

            item.quantity = 1;

            if(sum_quantity)
            {
                const quantity_from_item_response = this.getQuantityFromItemResponse(item, itemsParsed)
                if(quantity_from_item_response > 0) item.quantity = quantity_from_item_response
            }
            else
            {
                let tempItem = itemsParsed.find(ip => (ip.item_id == item.id) || (ip.id == item.id));
                if (tempItem !== undefined) {
                    item.quantity = tempItem.quantity
                }
            }

            // item.quantity = itemsParsed.find(ip => ip.item_id == item.id).quantity;
            item.warehouse_id = null;

            if(itemsParsed.length) {
                let itemParsed = itemsParsed.find(element => element.id == item.item.id);
                if (itemParsed) {
                    item.item.unit_price = itemParsed.unit_price;
                }
                
            }

            return item
        },
        getQuantityFromItemResponse(item, itemsParsed)
        {
            const group_items = itemsParsed.filter(ip => (ip.item_id == item.id) || (ip.id == item.id))

            return _.sumBy(group_items, function(row){
                return parseFloat(row.quantity)
            })
        },
        disabledSeries()
        {
            return (this.configuration.restrict_series_selection_seller && this.typeUser !== 'admin')
        },
        setDefaultSerieByDocument()
        {
            if(this.authUser.multiple_default_document_types)
            {
                const default_document_type_serie = _.find(this.authUser.default_document_types, { document_type_id : this.form.document_type_id})

                if(default_document_type_serie)
                {
                    const exist_serie = _.find(this.series, { id : default_document_type_serie.series_id})
                    if(exist_serie) this.form.series_id = default_document_type_serie.series_id
                }
            }

        },
        // #307 Ajuste para seleccionar automaticamente el tipo de comprobante y serie
        setDefaultDocumentType(from_function) {

            if(this.authUser.multiple_default_document_types) return

            this.default_series_type = this.config.user.serie;
            this.default_document_type = this.config.user.document_id;
            // if (this.default_document_type === undefined) this.default_document_type = null;
            // if (this.default_series_type === undefined) this.default_series_type = null;

            let alt = _.find(this.document_types, {'id': this.default_document_type});
            if (this.default_document_type !== null && alt !== undefined) {
                this.form.document_type_id = this.default_document_type;
                this.changeDocumentType()
                alt = _.find(this.series, {'id': this.default_series_type});
                if (this.default_series_type !== null && alt !== undefined) {
                    this.form.series_id = this.default_series_type;
                }
            }
        },
        onPrepareDataEstablishment(data)
        {
            if(this.isFromExternalDocument)
            {
                this.form.establishment_id = this.establishment.id
            }
            else
            {
                this.form.establishment_id = data.establishment_id
            }
        },
        async onSetFormData(data) {
            // carga informacion de un documento previo al formulario
            // console.log('onSetFormData')
            this.currency_type = await _.find(this.currency_types, {'id': data.currency_type_id})

            /*
            this.form.establishment_id = data.establishment_id;
            */

            this.onPrepareDataEstablishment(data)

            this.form.document_type_id = data.document_type_id;
            // this.form.series = data.series; //form.series no llena el selector
            if(this.table !== 'quotations') {
                 this.$store.commit('setSeries', this.onSetSeries(data.document_type_id, data.series))
            } else {
                // this.series = this.onSetSeries(this.form.document_type_id, this.series);
                this.changeDocumentType()
            }
            this.form.id = data.id;
            this.form.hash = data.hash;
            this.form.number = data.number;
            this.form.date_of_issue = moment(data.date_of_issue).format('YYYY-MM-DD');
            this.form.time_of_issue = data.time_of_issue;
            this.form.customer_id = data.customer_id;
            this.form.currency_type_id = data.currency_type_id;
            this.form.exchange_rate_sale = data.exchange_rate_sale;
            this.form.external_id = data.external_id;
            this.form.filename = data.filename;
            this.form.group_id = data.group_id;
            this.form.perception = data.perception;
            this.form.note = data.note;
            this.form.plate_number = data.plate_number;
            this.form.payments = data.payments;
            this.form.prepayments = data.prepayments || [];
            this.form.legends = [];
            this.form.service_country_id = data.service_country_id || null;
            // this.form.detraction = data.detraction;
            this.form.detraction = data.detraction ? data.detraction : {}
            this.form.sale_notes_relateds = data.sale_notes_relateds ? data.sale_notes_relateds : null
            this.form.affectation_type_prepayment = data.affectation_type_prepayment;
            this.form.purchase_order = data.purchase_order;
            this.form.pending_amount_prepayment = data.pending_amount_prepayment || 0;
            this.form.payment_method_type_id = data.payment_method_type_id;
            this.form.charges = data.charges || [];
            this.form.discounts = this.prepareDataGlobalDiscount(data)
            // this.form.discounts = data.discounts || [];
            this.form.seller_id = data.seller_id;
            this.form.items = this.onPrepareItems(data.items);
            // this.series = this.onSetSeries(data.document_type_id, data.series);
            this.form.state_type_id = data.state_type_id;
            this.form.total_discount = parseFloat(data.total_discount);
            this.form.total_exonerated = parseFloat(data.total_exonerated);
            this.form.total_exportation = parseFloat(data.total_exportation);
            this.form.total_free = parseFloat(data.total_free);
            this.form.total_igv = parseFloat(data.total_igv);
            this.form.total_isc = parseFloat(data.total_isc);
            this.form.total_base_isc = parseFloat(data.total_base_isc);
            this.form.total_base_other_taxes = parseFloat(data.total_base_other_taxes);
            this.form.total_other_taxes = parseFloat(data.total_other_taxes);
            this.form.total_plastic_bag_taxes = parseFloat(data.total_plastic_bag_taxes);
            this.form.total_prepayment = parseFloat(data.total_prepayment);
            this.form.total_taxed = parseFloat(data.total_taxed);
            this.form.total_taxes = parseFloat(data.total_taxes);
            this.form.total_unaffected = parseFloat(data.total_unaffected);
            this.form.total_value = parseFloat(data.total_value);
            this.form.total_charge = parseFloat(data.total_charge);
            this.form.total = parseFloat(data.total);
            this.form.subtotal = parseFloat(data.subtotal);
            this.form.total_igv_free = parseFloat(data.total_igv_free);
            this.form.series_id = this.onSetSeriesId(data.document_type_id, data.series);
            this.form.operation_type_id = data.invoice ? data.invoice.operation_type_id : data.operation_type_id;
            this.form.terms_condition = data.terms_condition || '';
            this.form.guides = data.guides || [];
            this.form.show_terms_condition = data.terms_condition ? true : false;
            this.form.attributes = [];
            this.form.customer = data.customer;
            this.form.has_prepayment = false;
            this.form.actions = {
                format_pdf: 'a4',
            };
            this.form.hotel = {};
            this.form.transport = {};
            this.form.customer_address_id = null;
            this.form.type = 'invoice';
            this.form.invoice = {
                operation_type_id: data.invoice ? data.invoice.operation_type_id : data.operation_type_id,
                date_of_due: data.invoice ? data.invoice.date_of_due : data.date_of_due,
            };
            // this.form.payment_condition_id = '01';

            let is_credit_installments = await _.find(data.fee, {payment_method_type_id: null})
            this.form.payment_condition_id = (is_credit_installments) ? '03' : data.payment_condition_id;
            this.form.fee = data.fee;
            this.form.retention = data.retention


            this.form.quotation_id = data.quotation_id;

            this.form.additional_information = this.onPrepareAdditionalInformation(data.additional_information);

            // this.form.additional_information = data.additional_information;
            // this.form.fee = [];
            this.prepareDataDetraction()
            this.prepareDataRetention()

            if (!data.guides) {
                this.clickAddInitGuides();
            }

            if(this.isGeneratedFromExternal)
            {
                this.preparePaymentsFee(data)
            }

            await this.reloadDataCustomers(this.form.customer_id)

            this.establishment = data.establishment;

            this.changeDateOfIssue();
            // await this.filterCustomers();
            this.updateChangeDestinationSale();

            this.prepareDataCustomer()
            this.monto_pagar_sin_dcto =Number(data.monto_pagar_sin_dcto) || 0
            this.total_original = this.monto_pagar_sin_dcto
            this.calculateTotal();
            // this.currency_type = _.find(this.currency_types, {'id': this.form.currency_type_id})

            this.filterSeriesForTable()

            //this.total_global_discount = parseFloat(data.dcto_monto_input) || 0
            //this.monto_pagar_sin_dcto = parseFloat(data.monto_pagar_sin_dcto) || 0
            setTimeout(() => {
                this.form.rounding = parseFloat(data.rounding) || 0
            }, 1200)
        },
        filterSeriesForTable()
        {
            if(this.table)
            {
                this.filterSeries()
            }
        },
        preparePaymentsFee(data)
        {
            if(this.isCreditPaymentCondition)
            {
                // credito
                if (this.form.payment_condition_id === '02')
                {
                    this.clickAddFeeNew()
                    const index = 0
                    this.readonly_date_of_due = true

                    this.form.fee[index].payment_method_type_id = data.document_payment_method_type.id
                    this.form.fee[index].amount = _.sumBy(data.data_payments_fee, 'payment')

                    this.changePaymentMethodType(index)
                }
            }
        },
        prepareDataGlobalDiscount(data)
        {
            const discounts = data.discounts
        ? Object.values(data.discounts)
        : []

        const globalDiscounts = discounts.filter(discount =>
            ['02', '03'].includes(
                this.normalizeDiscountTypeId(discount.discount_type_id)
            )
        )

        if (globalDiscounts.length > 0) {
            const firstDiscount = globalDiscounts[0]

            if (
                firstDiscount.is_amount !== undefined &&
                firstDiscount.is_amount !== null
            ) {
                this.is_amount = firstDiscount.is_amount
            }

            const savedInput = Number(data.dcto_monto_input)

            if (Number.isFinite(savedInput) && savedInput > 0) {
                this.total_global_discount = savedInput
            } else if (!this.is_amount) {
                this.total_global_discount =
                    Number(firstDiscount.factor) * 100
            } else {
                // Sin dcto_monto_input (documentos previos a la columna o creados por API):
                // se reconstruye desde los importes guardados. El importe del código 02 va
                // neto de IGV, así que se lleva a bruto para recuperar lo que se digitó.
                const igvFactor = 1 + (Number(this.percentage_igv) || 0)

                this.total_global_discount = _.round(
                    globalDiscounts.reduce((sum, discount) => {
                        const amount = Number(discount.amount) || 0
                        const affectsBase =
                            this.normalizeDiscountTypeId(discount.discount_type_id) === '02'

                        return sum + (affectsBase ? amount * igvFactor : amount)
                    }, 0),
                    2
                )
            }
        }

        return discounts
        },
        async prepareDataCustomer(has_customer_address_id = false) {

            this.customer_addresses = [];
            let customer = await _.find(this.customers, {'id': this.form.customer_id})
            this.customer_addresses = customer ? customer.addresses : []
            if (!has_customer_address_id) {
                this.form.customer_address_id = this.form.customer ? this.form.customer.address_id : null
            }

            if (customer && customer.address) {
                this.customer_addresses.unshift({
                    id: null,
                    address: customer.address
                })
            }

        },
        prepareDataRetention() {

            this.form.has_retention = !_.isEmpty(this.form.retention)

            if (this.form.has_retention)
            {
                this.setTotalPendingAmountRetention(this.form.retention.amount)

                this.retention_query_data = { ...this.form.retention }
            }

        },
        async prepareDataDetraction() {

            // this.has_data_detraction = (this.form.detraction) ? true : false
            this.has_data_detraction = !_.isEmpty(this.form.detraction)

            if (this.has_data_detraction) {

                let legend_value = (this.form.operation_type_id === '1001') ? 'Operación sujeta a detracción' : 'Operación Sujeta a Detracción - Servicios de Transporte - Carga'
                let legend = await _.find(this.form.legends, {'code': '2006'})
                if (!legend) this.form.legends.push({code: '2006', value: legend_value})

            }

        },
        updateChangeDestinationSale() {

            if (this.form.payment_condition_id == '01') {

                if (this.config.destination_sale && this.payment_destinations.length > 0) {
                    let cash = _.find(this.payment_destinations, {id: 'cash'})
                    if (cash) {
                        if (this.form.payments[0] !== undefined) {
                            this.form.payments[0].payment_destination_id = cash.id
                        } else {
                            // this.form.payments.push({
                            //     payment_destination_id: cash.id, //genera error al editar cpe enviado desde api
                            // })

                        }
                    } else {
                        this.form.payment_destination_id = this.payment_destinations[0].id
                        this.form.payments[0].payment_destination_id = this.payment_destinations[0].id
                    }
                }

            }
        },
        onPrepareAdditionalInformation(data) {
            let obs = null
            if (Array.isArray(data)) {
                if (data.length > 0) {
                    if (data[0] == '') {
                        return obs;
                    }
                }
                return data.join('|')
            }

            return data;
        },
        onPrepareItems(items) {
            return items.map(i => {

                if(this.table)
                {
                    i.unit_price_value = i.unit_value;
                    i.input_unit_price_value = (i.item.has_igv) ? i.item.unit_price : i.unit_value;
                }
                else
                {
                    i.unit_price_value = i.unit_value;
                    i.input_unit_price_value = (i.item.has_igv) ? i.unit_price : i.unit_value;
                }

                i.discounts = (i.discounts) ? Object.values(i.discounts) : []
                // i.discounts = i.discounts || [];
                i.charges = i.charges || [];
                i.attributes = i.attributes || [];
                i.item.id = i.item_id;
                i.additional_information = this.onPrepareAdditionalInformation(i.additional_information);
                i.item = this.onPrepareIndividualItem(i);
                return i;
            });
        },
        onPrepareIndividualItem(data) {

            let new_item = data.item
            let currency_type = _.find(this.currency_types, {'id': this.form.currency_type_id})

            new_item.currency_type_id = currency_type.id
            new_item.currency_type_symbol = currency_type.symbol

            new_item.sale_affectation_igv_type_id = data.affectation_igv_type_id

            if(this.table)
            {
                new_item.sale_unit_price = new_item.unit_price
                new_item.unit_price = new_item.unit_price
            }
            else
            {
                new_item.sale_unit_price = data.unit_price
                // new_item.unit_price = data.unit_price
            }

            return new_item
        },
        onSetSeriesId(documentType, serie) {
            if (Array.isArray(this.all_series) && this.all_series.length) {
                const find = this.all_series.find(s => s.document_type_id == documentType && s.number == serie);
                if (find) {
                    return find.id;
                }
            }
            return null;
        },
        onSetSeries(documentType, serie) {
            // console.log('onSetSeries')
            const find = this.all_series.find(s => s.document_type_id == documentType && s.number == serie);
            if (find) {
                return [find];
            }
            return [];
        },
        getPrepayment(index) {
            return _.find(this.prepayment_documents, {id: this.form.prepayments[index].document_id})
        },
        inputAmountPrepayment(index) {

            let prepayment = this.getPrepayment(index)

            if (parseFloat(this.form.prepayments[index].total) > parseFloat(prepayment.total)) {

                this.form.prepayments[index].total = prepayment.total
                this.$message.error('El monto debe ser menor o igual al del anticipo');

            }

            this.form.prepayments[index].amount = (this.form.affectation_type_prepayment == 10)
                ? _.round(this.form.prepayments[index].total / (1 + this.percentage_igv), 2)
                : this.form.prepayments[index].total

            this.changeTotalPrepayment()

        },
        changeDestinationSale() {
            if (this.config.destination_sale && this.payment_destinations.length > 0) {
                let cash = _.find(this.payment_destinations, {id: 'cash'})
                if (cash) {
                    this.form.payments[0].payment_destination_id = cash.id
                } else {
                    this.form.payment_destination_id = this.payment_destinations[0].id
                    this.form.payments[0].payment_destination_id = this.payment_destinations[0].id
                }
            }
        },
        changePaymentDestination(index) {
            // if(this.form.payments[index].payment_method_type_id=='01'){
            //     this.payment_destinations = this.cash
            // }else{
            //     this.payment_destinations = this.payment_destinations
            // }
        },
        changeEnabledPayments() {
            // this.clickAddPayment()
            // this.form.date_of_due = this.form.date_of_issue
            // this.readonly_date_of_due = false
            // this.form.payment_method_type_id = null
        },
        changePaymentMethodType(index) {

            let id = '01';
            if (this.form.payments[index] !== undefined &&
                this.form.payments[index].payment_method_type_id !== undefined) {
                id = this.form.payments[index].payment_method_type_id;
            } else if (this.form.fee[index] !== undefined &&
                this.form.fee[index].payment_method_type_id !== undefined) {
                id = this.form.fee[index].payment_method_type_id;
            }
            let payment_method_type = _.find(this.payment_method_types, {'id': id});

            if (payment_method_type.number_days) {

                this.form.date_of_due = moment(this.form.date_of_issue).add(payment_method_type.number_days, 'days').format('YYYY-MM-DD')
                // this.form.payments = []
                this.enabled_payments = false
                this.readonly_date_of_due = true
                this.form.payment_method_type_id = payment_method_type.id

                let date = moment(this.form.date_of_issue).add(payment_method_type.number_days, 'days').format('YYYY-MM-DD')

                // let date = moment()
                //     .add(payment_method_type.number_days, 'days')
                //     .format('YYYY-MM-DD')

                if (this.form.fee !== undefined) {
                    for (let index = 0; index < this.form.fee.length; index++) {
                        this.form.fee[index].date = date;
                    }
                }

            } else if (payment_method_type.id == '09') {

                this.form.payment_method_type_id = payment_method_type.id
                this.form.date_of_due = this.form.date_of_issue
                // this.form.payments = []
                this.enabled_payments = false

            } else {

                this.form.date_of_due = this.form.date_of_issue
                this.readonly_date_of_due = false
                this.form.payment_method_type_id = null
                this.enabled_payments = true

            }

        },
        selectDocumentType() {
            this.form.document_type_id = (this.select_first_document_type_03) ? '03' : '01'
        },
        keyupCustomer() {

            if (this.input_person.number) {

                if (!isNaN(parseInt(this.input_person.number))) {

                    switch (this.input_person.number.length) {
                        case 8:
                            this.input_person.identity_document_type_id = '1'
                            this.showDialogNewPerson = true
                            break;

                        case 11:
                            this.input_person.identity_document_type_id = '6'
                            this.showDialogNewPerson = true
                            break;
                        default:
                            this.input_person.identity_document_type_id = '6'
                            this.showDialogNewPerson = true
                            break;
                    }
                }
            }
        },
        addDocumentDetraction(detraction) {
            this.form.detraction = detraction
            // this.has_data_detraction = (detraction.pay_constancy || detraction.detraction_type_id || detraction.payment_method_id || (detraction.amount && detraction.amount >0)) ? true:false
            this.has_data_detraction = (detraction) ? detraction.has_data_detraction : false

            this.changeDetractionType()
        },
        setDataServiceCountry() {
            if (this.form.operation_type_id === '0208') {
                this.showDialogServiceCountry = true
            } else {
                this.form.service_country_id = null
            }
        },
        addServiceCountry(country_id) {
            this.form.service_country_id = country_id
        },
        clickAddItemInvoice() {
            this.recordItem = null
            this.showDialogAddItem = true
        },
        getFormatUnitPriceRow(unit_price) {
            return _.round(unit_price, 6)
            // hacer un .toFixed(2)
            // return unit_price.toFixed(6)
        },
        discountGlobalPrepayment() {

            let global_discount = 0
            let sum_total_prepayment = 0

            this.form.prepayments.forEach((item) => {
                global_discount += parseFloat(item.amount)
                sum_total_prepayment += parseFloat(item.total)
            })

            // let base = (this.form.affectation_type_prepayment == 10) ? parseFloat(this.form.total_taxed):parseFloat(this.form.total_exonerated)
            let base = 0

            switch (this.form.affectation_type_prepayment) {
                case 10:
                    base = parseFloat(this.form.total_taxed) + global_discount
                    // base = parseFloat(this.form.total_taxed)
                    break;
                case 20:
                    base = parseFloat(this.form.total_exonerated) + global_discount
                    break;
                case 30:
                    base = parseFloat(this.form.total_unaffected) + global_discount
                    break;
            }

            let amount = _.round(global_discount, 2)
            let factor = _.round(amount / base, 5)

            this.form.total_prepayment = _.round(sum_total_prepayment, 2)
            // this.form.total_prepayment = _.round(global_discount, 2)

            if (this.form.affectation_type_prepayment == 10) {


                let discount = _.find(this.form.discounts, d => this.normalizeDiscountTypeId(d.discount_type_id) === '04')

                if (global_discount > 0 && !discount) {

                    this.form.total_discount = _.round(amount, 2)
                    this.form.total_taxed = _.round(this.form.total_taxed - amount, 2)
                    this.form.total_igv = _.round(this.form.total_taxed * this.percentage_igv, 2)
                    this.form.total_taxes = _.round(this.form.total_igv, 2)
                    this.form.total = _.round(this.form.total_taxed + this.form.total_taxes + parseFloat(this.form.rounding || 0), 2)

                    this.form.discounts.push({
                        discount_type_id: "04",
                        description: "Descuentos globales por anticipos gravados que afectan la base imponible del IGV/IVAP",
                        factor: factor,
                        amount: amount,
                        base: base
                    })

                } else {

                    let pos = this.form.discounts.indexOf(discount);

                    if (pos > -1) {

                        this.form.total_discount = _.round(amount, 2)
                        this.form.total_taxed = _.round(this.form.total_taxed - amount, 2)
                        this.form.total_igv = _.round(this.form.total_taxed * this.percentage_igv, 2)
                        this.form.total_taxes = _.round(this.form.total_igv, 2)
                        this.form.total = _.round(this.form.total_taxed + this.form.total_taxes + parseFloat(this.form.rounding || 0), 2)

                        this.form.discounts[pos].base = base
                        this.form.discounts[pos].amount = amount
                        this.form.discounts[pos].factor = factor

                    }

                }

            } else if (this.form.affectation_type_prepayment == 20) {

                let exonerated_discount = _.find(this.form.discounts, d => this.normalizeDiscountTypeId(d.discount_type_id) === '05')

                this.form.total_discount = _.round(amount, 2)
                this.form.total_exonerated = _.round(this.form.total_exonerated - amount, 2)
                this.form.total = _.round(this.form.total_exonerated + parseFloat(this.form.rounding || 0), 2)

                if (global_discount > 0 && !exonerated_discount) {
                    this.form.discounts.push({
                        discount_type_id: '05',
                        description: 'Descuentos globales por anticipos exonerados',
                        factor: factor,
                        amount: amount,
                        base: base
                    })

                } else {

                    let position = this.form.discounts.indexOf(exonerated_discount);

                    if (position > -1) {

                        this.form.discounts[position].base = base
                        this.form.discounts[position].amount = amount
                        this.form.discounts[position].factor = factor

                    }

                }

            } else if (this.form.affectation_type_prepayment == 30) {

                let unaffected_discount = _.find(this.form.discounts, d => this.normalizeDiscountTypeId(d.discount_type_id) === '06')

                this.form.total_discount = _.round(amount, 2)
                this.form.total_unaffected = _.round(this.form.total_unaffected - amount, 2)
                this.form.total = _.round(this.form.total_unaffected + parseFloat(this.form.rounding || 0), 2)

                if (global_discount > 0 && !unaffected_discount) {
                    this.form.discounts.push({
                        discount_type_id: '06',
                        description: 'Descuentos globales por anticipos inafectos',
                        factor: factor,
                        amount: amount,
                        base: base
                    })
                } else {
                    let position = this.form.discounts.indexOf(unaffected_discount);
                    if (position > -1) {
                        this.form.discounts[position].base = base
                        this.form.discounts[position].amount = amount
                        this.form.discounts[position].factor = factor

                    }

                }
            }

        },
        async changeDocumentPrepayment(index) {

            let prepayment = await _.find(this.prepayment_documents, {id: this.form.prepayments[index].document_id})

            this.form.prepayments[index].number = prepayment.description
            this.form.prepayments[index].document_type_id = prepayment.document_type_id
            this.form.prepayments[index].amount = prepayment.amount
            this.form.prepayments[index].total = prepayment.total

            await this.changeTotalPrepayment()


        },
        clickAddPrepayment() {
            this.form.prepayments.push({
                document_id: null,
                number: null,
                document_type_id: null,
                amount: 0,
                total: 0,
            });

            this.changeTotalPrepayment()
        },
        clickRemovePrepayment(index) {

            this.form.prepayments.splice(index, 1)
            this.changeTotalPrepayment()
            if (this.form.prepayments.length == 0)
                this.deletePrepaymentDiscount()

        },
        async changePrepaymentDeduction() {

            this.form.prepayments = []
            this.form.total_prepayment = 0
            await this.deletePrepaymentDiscount()

            if (this.prepayment_deduction) {

                await this.initialValueATPrepayment()
                await this.changeTotalPrepayment()
                await this.getDocumentsPrepayment()

            } else {

                // this.form.total_prepayment = 0
                // await this.deletePrepaymentDiscount()
                this.cleanValueATPrepayment()
            }

        },
        setPendingAmount() {
            this.form.pending_amount_prepayment = this.form.has_prepayment ? this.form.total : 0
        },
        initialValueATPrepayment() {
            this.form.affectation_type_prepayment = (!this.form.affectation_type_prepayment) ? 10 : this.form.affectation_type_prepayment
        },
        cleanValueATPrepayment() {
            this.form.affectation_type_prepayment = null
        },
        changeHasPrepayment() {

            if (this.form.has_prepayment) {
                this.initialValueATPrepayment()
            } else {
                this.cleanValueATPrepayment()
            }

            this.setPendingAmount()

        },
        async changeAffectationTypePrepayment() {

            await this.initialValueATPrepayment()

            if (this.prepayment_deduction) {

                this.form.total_prepayment = 0
                await this.deletePrepaymentDiscount()
                await this.changePrepaymentDeduction()
            }

        },
        async deletePrepaymentDiscount() {

            let discount = await _.find(this.form.discounts, {'discount_type_id': '04'})
            let discount_exonerated = await _.find(this.form.discounts, {'discount_type_id': '05'})
            let discount_unaffected = await _.find(this.form.discounts, {'discount_type_id': '06'})

            let pos = this.form.discounts.indexOf(discount)
            if (pos > -1) {
                this.form.discounts.splice(pos, 1)
                this.changeTotalPrepayment()
            }

            let pos_exonerated = this.form.discounts.indexOf(discount_exonerated)
            if (pos_exonerated > -1) {
                this.form.discounts.splice(pos_exonerated, 1)
                this.changeTotalPrepayment()
            }

            let pos_unaffected = this.form.discounts.indexOf(discount_unaffected)
            if (pos_unaffected > -1) {
                this.form.discounts.splice(pos_unaffected, 1)
                this.changeTotalPrepayment()
            }

        },
        getDocumentsPrepayment() {
            this.$http.get(`/${this.resource}/prepayments/${this.form.affectation_type_prepayment}`).then((response) => {
                this.prepayment_documents = response.data
            })
        },
        changeTotalPrepayment() {
            this.calculateTotal()
        },
        isActiveBussinessTurn(value) {
            return (_.find(this.business_turns, {'value': value})) ? true : false
        },
        visibleDialogReportCustomer() {
            this.report_to_customer_id = this.form.customer_id
            this.showDialogReportCustomer = true
        },
        clickAddDocumentHotel() {
            this.showDialogFormHotel = true
        },
        clickAddDocumentTransport() {
            this.showDialogFormTransport = true
        },
        addDocumentHotel(hotel) {
            this.form.hotel = hotel
        },
        addDocumentTransport(transport) {
            this.form.transport = transport
        },
        changeIsReceivable() {

        },
        clickAddPayment() {
            let id = '01';
            if (this.cash_payment_metod !== undefined &&
                this.cash_payment_metod[0] !== undefined) {
                id = this.cash_payment_metod[0].id
            }
            let total = 0;
            if (this.form.total !== undefined) {
                total = this.form.total
            }
            this.form.date_of_due = moment().format('YYYY-MM-DD');

            let payment_method_type = null
            if (this.payment_method_types) {
                payment_method_type = this.payment_method_types.filter(item => item.is_default === true)
            }

            this.form.payments.push({
                id: null,
                document_id: null,
                date_of_payment: moment().format('YYYY-MM-DD'),
                // payment_method_type_id: id,
                payment_method_type_id: (payment_method_type && payment_method_type.length > 0) ? payment_method_type[0].id : id,
                reference: null,
                payment_destination_id: this.getPaymentDestinationId(),
                payment: total,

                payment_received: true,
                filename: null,
                temp_path: null,
                file_list: [],
            });

            this.calculatePayments()

        },
        getPaymentDestinationId() {

            if (this.config.destination_sale &&
                this.payment_destinations.length > 0) {

                let cash = _.find(this.payment_destinations, {id: 'cash'})

                return (cash) ? cash.id : this.payment_destinations[0].id

            }

            return null

        },
        clickCancel(index) {
            this.form.payments.splice(index, 1);
            this.calculatePayments()
        },
        async ediItem(row, index) {
            row.indexi = index
            this.recordItem = row
            this.showDialogAddItem = true
        },
        searchRemoteCustomers(input) {

            if (input.length > 0) {
                this.loading_search = true
                let parameters = `input=${input}&document_type_id=${this.form.document_type_id}&operation_type_id=${this.form.operation_type_id}`

                this.$http.get(`/${this.resource}/search/customers?${parameters}`)
                    .then(response => {
                        console.log('sarch remote customers response')
                        console.log(response)
                        this.customers = response.data.customers
                        this.loading_search = false
                        this.input_person.number = (this.customers.length == 0) ? input : null

                        /* if (this.customers.length == 0) {
                            this.filterCustomers()
                            this.input_person.number = input
                        } */
                    })
            } else {
                this.filterCustomers()
                this.input_person.number = null
            }

        },
        changeRetention() {

            if (this.form.has_retention) {

                let base = this.form.total
                let percentage = _.round(parseFloat(this.config.igv_retention_percentage) / 100, 5)
                let amount = _.round(base * percentage, 2)

                let amount_pen = amount;
                let amount_usd = _.round(amount / this.form.exchange_rate_sale, 2);
                if(this.form.currency_type_id === 'USD') {
                    amount_usd = amount;
                    // amount_pen = _.round(amount * this.form.exchange_rate_sale, 2);
                    let total_pen = _.round(base * this.form.exchange_rate_sale, 2) // total en soles
                    amount_pen = _.round(total_pen * percentage, 2)
                }


                this.form.retention = {
                    base: base,
                    code: '62', //Código de Retención del IGV
                    amount: amount,
                    percentage: percentage,
                    currency_type_id: this.form.currency_type_id,
                    exchange_rate: this.form.exchange_rate_sale,
                    amount_pen: amount_pen,
                    amount_usd: amount_usd,
                }

                this.setDataVoucherRetention()
                this.setTotalPendingAmountRetention(amount)

            } else {
                this.total_pending_payment_edited = false
                this.form.retention = {}
                this.form.total_pending_payment = 0
                this.calculateAmountToPayments()
            }

        },
        setDataVoucherRetention()
        {
            if(this.isUpdateDocument && this.retention_query_data)
            {
                this.form.retention.voucher_date_of_issue = this.retention_query_data.voucher_date_of_issue
                this.form.retention.voucher_number = this.retention_query_data.voucher_number
                this.form.retention.voucher_amount = this.retention_query_data.voucher_amount
                this.form.retention.voucher_filename = this.retention_query_data.voucher_filename
            }
        },
        setTotalPendingAmountRetention(amount) {

            //monto neto pendiente aplica si la condicion de pago es credito
            this.form.total_pending_payment = ['02', '03'].includes(this.form.payment_condition_id) ? this.form.total - amount : 0
            this.calculateAmountToPayments()

        },
        initInputPerson() {
            this.input_person = {
                number: null,
                identity_document_type_id: null
            }
        },
        resetForm() {
            this.has_sale_note = false
            this.activePanel = 0
            this.initForm()
            this.clickAddPayment()
            // this.form.currency_type_id = (this.currency_types.length > 0)?this.currency_types[0].id:null
            this.form.establishment_id = (this.establishments.length > 0) ? this.establishments[0].id : null
            this.form.document_type_id = (this.document_types.length > 0) ? this.document_types[0].id : null
            this.form.operation_type_id = (this.operation_types.length > 0) ? this.operation_types[0].id : null
            this.form.seller_id = (this.sellers.length > 0) ? this.idUser : null;
            this.selectDocumentType()
            this.changeEstablishment()
            this.changeDocumentType()
            this.changeDateOfIssue()
            this.changeCurrencyType()
            // this.changeDestinationSale()

        },
        async changeOperationType() {
            await this.filterCustomers();
            await this.setDataDetraction();
            await this.setDataServiceCountry();
        },
        // async filterDetractionTypes(){
        //     this.detraction_types =  await _.filter(this.all_detraction_types, {'operation_type_id':this.form.operation_type_id})
        // },
        async setDataDetraction() {

            if (this.form.operation_type_id === '1001') {

                this.showDialogDocumentDetraction = true

                // this.$message.warning('Sujeta a detracción');
                // await this.filterDetractionTypes();
                let legend = await _.find(this.form.legends, {'code': '2006'})
                if (!legend) this.form.legends.push({code: '2006', value: 'Operación sujeta a detracción'})
                this.form.detraction.bank_account = this.company.detraction_account
                // this.form.detraction.detraction_type_id = undefined

            } else if (this.form.operation_type_id === '1004') {

                this.showDialogDocumentDetraction = true
                let legend = await _.find(this.form.legends, {'code': '2006'})
                if (!legend) this.form.legends.push({
                    code: '2006',
                    value: 'Operación Sujeta a Detracción - Servicios de Transporte - Carga'
                })
                this.form.detraction.bank_account = this.company.detraction_account

            } else {
                this.total_pending_payment_edited = false
                _.remove(this.form.legends, {'code': '2006'})
                this.form.detraction = {}

            }

            this.calculateAmountToPayments()
        },
        async changeDetractionType() {

            if (this.form.detraction) {
                let round = this.config.detraction_amount_rounded_int ? 0 : 2;
                let total = this.form.total;
                
                if (this.form.currency_type_id == 'PEN') {

                    total = ((this.form.detraction.reference_value_service > this.form.total) && this.form.operation_type_id == '1004')?this.form.detraction.reference_value_service:this.form.total;

                    // this.form.detraction.amount = _.round(parseFloat(this.form.total) * (parseFloat(this.form.detraction.percentage) / 100), 2)
                    let amount = _.round(parseFloat(this.form.total) * (parseFloat(this.form.detraction.percentage) / 100), 2)
                    
                    // this.form.total_pending_payment = this.form.total - this.form.detraction.amount -- ANTERIOR
                    
                    this.form.detraction.amount = _.round(parseFloat(total) * (parseFloat(this.form.detraction.percentage) / 100), round)
                    this.form.total_pending_payment = this.form.total - this.form.detraction.amount // MONTO PENDIENTE
                } else {
                    total = ((this.form.detraction.reference_value_service > (parseFloat(this.form.total) * this.form.exchange_rate_sale)) && this.form.operation_type_id == '1004' )?this.form.detraction.reference_value_service:parseFloat(this.form.total) * this.form.exchange_rate_sale;

                    // this.form.detraction.amount = _.round((parseFloat(this.form.total) * this.form.exchange_rate_sale) * (parseFloat(this.form.detraction.percentage) / 100), 2)
                    // this.form.detraction.amount = _.round( total* (parseFloat(this.form.detraction.percentage) / 100), round)
                    let amount  = _.round( total* (parseFloat(this.form.detraction.percentage) / 100), 2) // MONTO DETRACCION SIN REDONDEAR
                    
                    // this.form.total_pending_payment = _.round(this.form.total - (this.form.detraction.amount / this.form.exchange_rate_sale), 2)
                    this.form.total_pending_payment = _.round(this.form.total - (amount / this.form.exchange_rate_sale), 2) 
                    this.form.detraction.amount = _.round( total* (parseFloat(this.form.detraction.percentage) / 100), round)


                }

                this.calculateAmountToPayments()

            }
        },
        calculateAmountToPayments() {

            // if(this.form.payments.length > 0){
            //     // this.form.payments[0].payment = this.form.total_pending_payment
            // }
            this.calculatePayments()
            this.calculateFee()
        },
        validateDetraction() {

            if (['1001', '1004'].includes(this.form.operation_type_id)) {

                let detraction = this.form.detraction

                let tot = (this.form.currency_type_id == 'PEN') ? this.form.total : (this.form.total * this.form.exchange_rate_sale)

                let total_restriction = (this.form.operation_type_id == '1001') ? 700 : 400
                let is_residues = detraction.detraction_type_id === '010' && this.form.operation_type_id == '1001' ? true : false

                if (tot <= total_restriction && !is_residues)
                    return {
                        success: false,
                        message: `El importe de la operación debe ser mayor a S/ ${total_restriction}.00 o equivalente en USD`
                    }

                if (!detraction.detraction_type_id)
                    return {success: false, message: 'El campo bien o servicio sujeto a detracción es obligatorio'}

                if (!detraction.payment_method_id)
                    return {success: false, message: 'El campo método de pago - detracción es obligatorio'}

                if (!detraction.bank_account)
                    return {success: false, message: 'El campo cuenta bancaria es obligatorio'}

                if (detraction.amount <= 0)
                    return {success: false, message: 'El campo total detracción debe ser mayor a cero'}

            }

            return {success: true}

        },
        changeEstablishment(number = null) {
            this.establishment = _.find(this.establishments, {'id': this.form.establishment_id})
            this.filterSeries()
            this.selectDefaultCustomer(number)
        },
        async selectDefaultCustomer(number = null) {
            if (this.establishment.customer_id && !number) {

                let temp_all_customers = this.all_customers;
                let temp_customers = this.customers;
                await this.$http.get(`/${this.resource}/search/customer/${this.establishment.customer_id}`).then((response) => {
                    console.log('response')
                    console.log(response)
                    let data_customer = response.data.customers
                    temp_all_customers = temp_all_customers.push(...data_customer)
                    temp_customers = temp_customers.push(...data_customer)
                })
                temp_all_customers = this.all_customers.filter((item, index, self) =>
                        index === self.findIndex((t) => (
                            t.id === item.id
                        ))
                )
                temp_customers = this.customers.filter((item, index, self) =>
                        index === self.findIndex((t) => (
                            t.id === item.id
                        ))
                )
                this.all_customers = temp_all_customers;
                this.customers = temp_customers;
                await this.filterCustomers()
                // this.form.customer_id = (this.customers.length > 0) ? this.establishment.customer_id : null
                let alt = _.find(this.customers, {'id': this.establishment.customer_id});
                // console.log(alt)

                if (alt !== undefined) {
                    this.form.customer_id = this.establishment.customer_id
                    if (alt.addresses) {
                        this.customer_addresses = []
                        this.customer_addresses = alt.addresses
                        const address = alt.addresses.find(element => element.main)
                        this.form.customer_address_id = address ? address.id : null
                    }
                    this.validateCustomerRetention(alt.identity_document_type_id)
                    let seller = this.sellers.find(element => element.id == alt.seller_id)
                    if (seller !== undefined) {
                        this.form.seller_id = seller.id
                    }

                    this.setCustomerAccumulatedPoints(alt.id, this.config.enabled_point_system)
                }


            }
        },
        changeDocumentType() {

            this.validateDateOfIssue()
            this.filterSeries();
            this.cleanCustomer();
            this.filterCustomers();
            this.setDefaultSerieByDocument()
        },
        cleanCustomer() {
            this.form.customer_id = null
            this.customer_addresses = []
            this.form.customer_address_id = null
        },
        dateValidError() {

            this.$message.error(`No puede seleccionar una fecha menor a ${this.configuration.shipping_time_days} día(s).`);
            // this.$message.error('No puede seleccionar una fecha menor a 6 días.');
            this.dateValid = false

        },
        validateDateOfIssue() {

            let minDate = moment().subtract(this.configuration.shipping_time_days, 'days')
            // let minDate = moment().subtract(7, 'days')

            // validar fecha de factura sin considerar configuracion
            if (moment(this.form.date_of_issue) < minDate && this.form.document_type_id === '01') {

                this.dateValidError()
            } else if (moment(this.form.date_of_issue) < minDate && this.config.restrict_receipt_date) {

                this.dateValidError()

            } else {
                this.dateValid = true
            }

        },
        async changeDateOfIssue() {

            this.validateDateOfIssue()

            this.form.date_of_due = this.form.date_of_issue
            // if (! this.isUpdate) {
            await this.searchExchangeRateByDate(this.form.date_of_issue).then(response => {
                this.form.exchange_rate_sale = response
            });
            await this.getPercentageIgv();
            this.changeCurrencyType();
            // }

            if (this.form.payment_condition_id === '03') {
                this.form.fee = this.form.fee.map(row => {
                    return {
                        ...row,
                        date: moment(this.form.date_of_issue, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')
                    }
                })
            }
        },
        assignmentDateOfPayment() {
            this.form.payments.forEach((payment) => {
                payment.date_of_payment = this.form.date_of_issue
            })
        },
        filterSeries() {
            // console.log('filterSeries');
            this.form.series_id = null
            let series = _.filter(this.all_series, {
                'establishment_id': this.form.establishment_id,
                'document_type_id': this.form.document_type_id,
                'contingency': this.is_contingency
            });
            if (this.form.document_type_id === this.config.user.document_id && this.typeUser == 'seller') {
                // Se filtra si el documento es el mismo que el establecido para el usuario.
                series = _.filter(this.all_series, {
                    'establishment_id': this.form.establishment_id,
                    'document_type_id': this.form.document_type_id,
                    'contingency': this.is_contingency,
                    'id': this.config.user.serie,

                });
            }

            //console.log(series);

            this.$store.commit('setSeries', series)
            this.form.series_id = (this.series.length > 0) ? this.series[0].id : null
        },
        filterCustomers() {
            if (['0101', '1001', '1004'].includes(this.form.operation_type_id)) {
                if (this.form.document_type_id === '01') {

                    if (!_.isNull(this.form.customer_id)) {
                        const cus = _.find(this.all_customers, {'id': this.form.customer_id});
                        if (cus && cus.identity_document_type_id !== '6') {
                            this.form.customer_id = null
                        }
                    }

                    this.customers = _.filter(this.all_customers, {'identity_document_type_id': '6'})
                } else {
                    if (this.document_type_03_filter) {
                        this.customers = _.filter(this.all_customers, (c) => {
                            return c.identity_document_type_id !== '6'
                        })
                    } else {
                        this.customers = this.all_customers
                    }
                }
            } else {
                this.customers = this.all_customers
            }
        },
        clickAddInitGuides() {
            this.form.guides.push({
                document_type_id: '09',
                number: null
            }, {
                document_type_id: '31',
                number: null
            })
        },
        clickAddGuide() {
            this.form.guides.push({
                document_type_id: null,
                number: null
            })
        },
        clickRemoveGuide(index) {
            this.form.guides.splice(index, 1)
        },
        async addRow(row) {
            console.log('valor row')
            console.log(row)
            let enable_barcode_quick_sale = false;
            if (this.$refs.item_search_quick_sale && this.$refs.item_search_quick_sale.search_item_by_barcode) {
                enable_barcode_quick_sale = this.$refs.item_search_quick_sale.search_item_by_barcode;
            }
            let enable_search_on_enter = false;
            if (this.$refs.item_search_quick_sale && this.$refs.item_search_quick_sale.searchOnEnter) {
                enable_search_on_enter = this.$refs.item_search_quick_sale.searchOnEnter;
            }
            // console.log('enable_barcode', this.$refs.item_search_quick_sale.search_item_by_barcode);
            if (this.recordItem) {
                //this.form.items.$set(this.recordItem.indexi, row)
                this.form.items[this.recordItem.indexi] = row
                this.recordItem = null

                if(this.config.enabled_point_system)
                {
                    this.setTotalExchangePoints()
                    this.recalculateUsedPointsForExchange(row)
                }

            } else if(enable_barcode_quick_sale || enable_search_on_enter) {
                let index = this.form.items.findIndex(item => item.item.internal_id === row.item.internal_id);
                if (index !== -1) {
                    let newItem = this.form.items[index];
                    newItem.quantity++;
                    let newRow = await calculateRowItem(newItem, row.item.currency_type_id, this.form.exchange_rate_sale, row.percentage_igv);
                    this.form.items[index] = newRow
                } else {
                    this.form.items.push(JSON.parse(JSON.stringify(row)));
                }
            } else {
                this.form.items.push(JSON.parse(JSON.stringify(row)));
            }

            await this.calculateTotal();
        },
        clickRemoveItem(index) {
            this.form.items.splice(index, 1)
            this.calculateTotal()

            if(this.config.enabled_point_system) this.setTotalExchangePoints()
        },
        changeCurrencyType() {
            this.currency_type = _.find(this.currency_types, {'id': this.form.currency_type_id})
            
            if (this.from_sale_note) {
                this.calculateTotal()
                return
            }
            
            let items = []
            this.form.items.forEach((row) => {
                items.push(calculateRowItem(row, this.form.currency_type_id, this.form.exchange_rate_sale, this.percentage_igv))
            });
            this.form.items = items
            this.calculateTotal()
        },
        calculateTotal() {
            this.total_pending_payment_edited = false
            let total_discount = 0
            let total_charge = 0
            let total_exportation = 0
            let total_taxed = 0
            let total_exonerated = 0
            let total_unaffected = 0
            let total_free = 0
            let total_igv = 0
            let total_value = 0
            let total = 0
            let total_plastic_bag_taxes = 0
            this.total_discount_no_base = 0

            let total_igv_free = 0
            let total_base_isc = 0
            let total_isc = 0

            // let total_free_igv = 0

            // **c
            let item_charges_no_afecta = 0
            let total_charge_46 = this.form.items.reduce((total, row) => total + parseFloat(row.charge_46), 0)
            this.form.items.forEach((row) => {

                let object_charges_no_afecta = 0
                // **c
                // console.log('de aca row')
                // console.log(row)
                // cargos
                if (row.charges && Array.isArray(row.charges)) {
                    row.charges.forEach((charge) => {
                        if (charge.charge_type_id === '48') {
                            object_charges_no_afecta += parseFloat(charge.amount)
                        }
                    })
                }
                item_charges_no_afecta += object_charges_no_afecta

                total_discount += parseFloat(row.total_discount)
                total_charge += parseFloat(row.total_charge)

                if (row.affectation_igv_type_id === '10') {
                    // total_taxed += parseFloat(row.total_value)
                    if (row.total_value_without_rounding) {
                        total_taxed += parseFloat(row.total_value_without_rounding)
                    } else {
                        total_taxed += parseFloat(row.total_value)
                    }
                }

                if (
                    row.affectation_igv_type_id === '20'  // 20,Exonerado - Operación Onerosa
                    // || row.affectation_igv_type_id === '21' // 21,Exonerado – Transferencia Gratuita
                ) {

                    // total_exonerated += parseFloat(row.total_value)

                    total_exonerated += (row.total_value_without_rounding) ? parseFloat(row.total_value_without_rounding) : parseFloat(row.total_value)
                }

                if (
                    row.affectation_igv_type_id === '30'  // 30,Inafecto - Operación Onerosa
                    || row.affectation_igv_type_id === '31'  // 31,Inafecto – Retiro por Bonificación
                    || row.affectation_igv_type_id === '32'  // 32,Inafecto – Retiro
                    || row.affectation_igv_type_id === '33'  // 33,Inafecto – Retiro por Muestras Médicas
                    || row.affectation_igv_type_id === '34'  // 34,Inafecto - Retiro por Convenio Colectivo
                    || row.affectation_igv_type_id === '35'  // 35,Inafecto – Retiro por premio
                    || row.affectation_igv_type_id === '36' // 36,Inafecto - Retiro por publicidad
                    // || row.affectation_igv_type_id === '37'  // 37,Inafecto - Transferencia gratuita
                ) {
                    total_unaffected += parseFloat(row.total_value)
                }

                if (row.affectation_igv_type_id === '40') {
                    total_exportation += parseFloat(row.total_value)
                }

                if (['10',
                    // '20', '21',
                    '20',
                    '30', '31', '32', '33', '34', '35', '36',
                    '40'].indexOf(row.affectation_igv_type_id) < 0) {
                    total_free += parseFloat(row.total_value)
                }

                if (['10',
                    '20', '21',
                    '30', '31', '32', '33', '34', '35', '36',
                    '40'].indexOf(row.affectation_igv_type_id) > -1) {
                    // total_igv += parseFloat(row.total_igv)
                    // total += parseFloat(row.total)
                    if (row.total_igv_without_rounding) {
                        total_igv += parseFloat(row.total_igv_without_rounding)
                    } else {
                        total_igv += parseFloat(row.total_igv)
                    }

                    // row.total_value_without_rounding = total_value
                    // row.total_base_igv_without_rounding = total_base_igv
                    // row.total_igv_without_rounding = total_igv
                    // row.total_taxes_without_rounding = total_taxes
                    // row.total_without_rounding = total

                    if (row.total_without_rounding) {
                        total += parseFloat(row.total_without_rounding)
                    } else {
                        total += parseFloat(row.total)
                    }


                }

                // console.log(row.total_value)

                if (!['21', '37'].includes(row.affectation_igv_type_id)) {
                    // total_value += parseFloat(row.total_value)
                    if (row.total_value_without_rounding) {
                        total_value += parseFloat(row.total_value_without_rounding)
                    } else {
                        total_value += parseFloat(row.total_value)
                    }
                }

                total_plastic_bag_taxes += parseFloat(row.total_plastic_bag_taxes)


                if (['11', '12', '13', '14', '15', '16'].includes(row.affectation_igv_type_id)) {

                    let unit_value = row.total_value / row.quantity
                    let total_value_partial = unit_value * row.quantity
                    // row.total_taxes = row.total_value - total_value_partial
                    row.total_taxes = row.total_value - total_value_partial + parseFloat(row.total_plastic_bag_taxes) //sumar icbper al total tributos

                    row.total_igv = total_value_partial * (row.percentage_igv / 100)
                    row.total_base_igv = total_value_partial
                    total_value -= row.total_value

                    total_igv_free += row.total_igv
                    total += parseFloat(row.total) //se agrega suma al total para considerar el icbper

                }

                //sum discount no base
                this.total_discount_no_base += this.sumDiscountsNoBaseByItem(row)

                // isc
                total_isc += parseFloat(row.total_isc)
                total_base_isc += parseFloat(row.total_base_isc)
            });

            // isc
            this.form.total_base_isc = _.round(total_base_isc, 2)
            this.form.total_isc = _.round(total_isc, 2)

            this.form.total_igv_free = _.round(total_igv_free, 2)
            this.form.total_discount = _.round(total_discount, 2)
            this.form.total_exportation = _.round(total_exportation, 2)
            this.form.total_taxed = _.round(total_taxed, 2)
            this.form.total_taxed_without_rounding = _.round(total_taxed, 5)
            this.form.total_exonerated = _.round(total_exonerated, 2)
            this.form.total_unaffected = _.round(total_unaffected, 2)
            this.form.total_free = _.round(total_free, 2)
            // this.form.total_igv = _.round(total_igv + total_free_igv, 2)
            this.form.total_igv = _.round(total_igv, 2)
            this.form.total_value = _.round(total_value, 2)
            // this.form.total_taxes = _.round(total_igv, 2)

            //impuestos (isc + igv + icbper)
            this.form.total_taxes = _.round(total_igv + total_isc + total_plastic_bag_taxes, 2);

            this.form.total_plastic_bag_taxes = _.round(total_plastic_bag_taxes, 2)

            this.form.subtotal = _.round(total, 2)
            this.form.total = _.round(total - this.total_discount_no_base + parseFloat(this.form.rounding || 0), 2)

            // this.form.subtotal = _.round(total + this.form.total_plastic_bag_taxes, 2)
            // this.form.total = _.round(total + this.form.total_plastic_bag_taxes - this.total_discount_no_base, 2)

            this.monto_pagar_sin_dcto = _.round(this.form.items.reduce((acc, item) => acc + (Number(item.total_original) || 0), 0), 2)

            // respaldo: si los ítems no traen la base, usar el valor de la nota de venta
            if (this.monto_pagar_sin_dcto <= 0 && this.monto_pagar_sin_dcto_sale_note > 0) {
                this.monto_pagar_sin_dcto = this.monto_pagar_sin_dcto_sale_note
            }
            // Number(row.total_original)

            if (this.enabled_discount_global)
                this.discountGlobal()

            if (this.prepayment_deduction)
                this.discountGlobalPrepayment()

            if (['1001', '1004'].includes(this.form.operation_type_id))
                this.changeDetractionType()

            if (this.form.has_retention) {
                this.changeRetention()
            }

            this.setTotalDefaultPayment()
            this.setPendingAmount()

            this.calculateFee();
            this.form.total_charge = 0;
            this.chargeGlobal()

            this.setTotalPointsBySale(this.config)
            // **c | PROBLEMA QUE SI SE PONE UN CARGO GENERAL EN EL INPUT SE RECHAZA LA FACTURA
            // console.log('this.form.charges')
            // console.log(this.form.charges)
            // if (object_charges_no_afecta.length > 0) {
            //     this.form.charges = object_charges_no_afecta
            //     this.form.total_charge = this.form.charges.reduce((total, item) => total + item.amount, 0)
            // }
            // this.form.total_charge = this.form.total_charge + object_charges_no_afecta
            this.form.total_charge += item_charges_no_afecta

            if (total_charge_46 > 0) {
                // let base = parseFloat(this.form.total_taxed)
                let base = parseFloat(this.form.total_value)
                let amount = total_charge_46
                let factor = parseFloat(amount / base).toFixed(5)
                let obj_charge = {
                    charge_type_id: '46',
                    description: 'Recargo al consumo y/o propinas',
                    factor: factor,
                    amount: parseFloat(amount).toFixed(2),
                    base: base
                }

                const exists_charge = this.form.charges.find(charge => charge.charge_type_id === '46')
                if (exists_charge) {
                    exists_charge.factor = factor
                    exists_charge.amount = parseFloat(amount).toFixed(2)
                    exists_charge.base = base
                } else {
                    this.form.charges.push(obj_charge)
                }


                this.form.total_charge += total_charge_46
            } else {
                // eliminanos de form.charges el que titpe charge_type_id = 46
                this.form.charges = this.form.charges.filter(charge => charge.charge_type_id !== '46')
            }
            this.form.total_charge_46 = total_charge_46
            console.log('this.form.charges ACA')
            console.log(this.form.charges)
        },
        sumDiscountsNoBaseByItem(row) {

            let sum_discount_no_base = 0

            if (row.discounts) {
                // if(row.discounts.length > 0){
                sum_discount_no_base = _.sumBy(row.discounts, (discount) => {
                    return (this.normalizeDiscountTypeId(discount.discount_type_id) === '01')? Number(discount.amount) || 0: 0})
                // }
            }

            return sum_discount_no_base
        },
        setTotalDefaultPayment() {

            // if (this.form.payments.length > 0) {

            //     this.form.payments[0].payment = this.form.total
            // }
            this.calculatePayments()
        },
        chargeGlobal() {
            let base = parseFloat(this.form.total)
            let charge_user = parseFloat(this.percentage_allowance_charge_user)
            if (!this.config.active_allowance_charge && !this.configuration.allow_charge_is_amount) {
                this.total_global_charge = _.round(base * (charge_user / 100), 2)
            } else if (this.config.active_allowance_charge && !this.configuration.allow_charge_is_amount) {
                this.total_global_charge = _.round(base * (charge_user / 100), 2)
            } else {
                this.total_global_charge = charge_user
            }

            if (this.total_global_charge == 0 || charge_user == 0) {
                this.deleteChargeGlobal()
                return
            }
            console.log('valor de this.form.charges ANTES')
            console.log(this.form.charges)

            let amount = parseFloat(this.total_global_charge)
            // let base = this.form.total_taxed + amount
            let factor = _.round(amount / base, 5)

            // console.log(base,factor, amount)

            let charge = _.find(this.form.charges, {charge_type_id: '50'})

            if (amount > 0 && !charge) {

                this.form.total_charge = _.round(amount, 2)
                this.form.total = _.round(this.form.total + this.form.total_charge, 2)

                this.form.charges.push({
                    charge_type_id: '50',
                    description: 'Cargos globales que no afectan la base imponible del IGV/IVAP',
                    factor: factor,
                    amount: amount,
                    base: base
                })

            } else {

                let pos = this.form.charges.indexOf(charge);

                if (pos > -1) {

                    this.form.total_charge = _.round(amount, 2)
                    this.form.total = _.round(this.form.total + this.form.total_charge, 2)

                    this.form.charges[pos].base = base
                    this.form.charges[pos].amount = amount
                    this.form.charges[pos].factor = factor

                }
            }
            console.log('valor de this.form.charges')
            console.log(this.form.charges)
            this.calculatePayments()

        },
        deleteChargeGlobal() {

            let charge = _.find(this.form.charges, {charge_type_id: '50'})
            let index = this.form.charges.indexOf(charge)

            if (index > -1) {
                this.form.charges.splice(index, 1)
                this.form.total_charge = 0
            }

        },
        changeTypeDiscount() {
            this.calculateTotal()
        },
        changeTotalGlobalDiscount() {
            this.total_original = this.form.total
            this.calculateTotal()
        },
        deleteDiscountGlobal() {
            this.global_discount_non_taxed = 0
            const globalDiscountIds = ['02', '03']
            const previousLength = this.form.discounts.length

            this.form.discounts = this.form.discounts.filter(discount => {
                return !globalDiscountIds.includes(this.normalizeDiscountTypeId(discount.discount_type_id))
            })

            /*const inputDiscount = Number(this.total_global_discount) || 0
            const taxedBase = Number(this.form.total_taxed_without_rounding) || 0
            const nonTaxedBase = _.round(
                (Number(this.form.total_exonerated) || 0) +
                (Number(this.form.total_unaffected) || 0),
                2
            )

            const hasTaxed = taxedBase > 0
            const hasNonTaxed = nonTaxedBase > 0

            if (hasTaxed && hasNonTaxed && inputDiscount > 0) {
                this.setMixedGlobalDiscount(inputDiscount, taxedBase, nonTaxedBase)
                return
            }*/

            if (previousLength !== this.form.discounts.length) {
                this.form.total_discount = this.getItemsTotalDiscount()
            }

        },
        setConfigGlobalDiscountType()
        {
            this.global_discount_type = _.find(this.global_discount_types, { id : this.configuration.global_discount_type_id})
        },
        setGlobalDiscount(factor, amount, base, type_discount = null)
        {
            const discountTypeId = type_discount || this.global_discount_type.id

            const discountType = _.find(this.global_discount_types, {
                id: discountTypeId
            })

            this.form.discounts.push({
                discount_type_id: discountTypeId,
                description: discountType
                    ? discountType.description
                    : this.global_discount_type.description,
                factor: factor,
                amount: amount,
                base: base,
                is_amount: this.is_amount
            })
        },
        discountGlobal() {

            this.deleteDiscountGlobal()

            // const total_percentage_products = this.form.items.reduce((total, row) => {
            //         const tip_percentage = parseFloat(row.item.tip_percentage)
            //         return total + (row.item.tip_percentage && !isNaN(tip_percentage) ? tip_percentage : 0)
            //     }, 0)

            const inputDiscount = Number(this.total_global_discount) || 0
            const taxedBase =
                Number(this.form.total_taxed_without_rounding) || 0

            // Solo operaciones onerosas:
            // 20 = Exonerado oneroso
            // 30 = Inafecto oneroso
            const nonTaxedBase = _.round(
                this.form.items.reduce((sum, row) => {
                    const affectationId = String(
                        row.affectation_igv_type_id
                    )

                    if (!['20', '30'].includes(affectationId)) {
                        return sum
                    }

                    const rawValue = row.total_value_without_rounding

                    const value =
                        rawValue !== null &&
                        rawValue !== undefined
                            ? Number(rawValue)
                            : Number(row.total_value)

                    return sum + (
                        Number.isFinite(value) ? value : 0
                    )
                }, 0),
                2
            )

            const hasTaxed = taxedBase > 0
            const hasNonTaxed = nonTaxedBase > 0
            if (!hasTaxed &&!hasNonTaxed &&inputDiscount > 0) {
                this.$message.error('No existen operaciones gravadas, exoneradas o inafectas onerosas para distribuir el descuento')
                return
            }
            if (hasTaxed && hasNonTaxed && inputDiscount > 0) {
                this.setMixedGlobalDiscount(
                    inputDiscount,
                    taxedBase,
                    nonTaxedBase
                )
                return
            }

            let input_global_discount_ = inputDiscount
            if (!hasTaxed && hasNonTaxed && inputDiscount > 0) {
                // console.log('exonerado o inafecto')

                let base = parseFloat(this.form.total)
                let amount = 0
                // let amount_ = 0
                let factor = 0

                if (this.is_amount)
                {
                    // amount = parseFloat(input_global_discount_ / (1 + (total_percentage_products / 100))).toFixed(5)
                    // amount_ = input_global_discount_

                    amount = input_global_discount_
                    factor = _.round(amount / base, 5)
                }
                else
                {
                    factor = _.round(input_global_discount_ / 100, 5)
                    amount = factor * base
                }

                // this.form.total_discount = _.round(amount_, 5)
                this.form.total_discount = _.round(this.getItemsTotalDiscount() + amount, 5)

                // descuentos que afectan la bi
                if(this.isGlobalDiscountBase)
                {

                    // this.form.total_taxed = _.round(base - this.form.total_discount, 2)
                    // this.form.total_value = this.form.total_taxed
                    // this.form.total_igv = _.round(this.form.total_taxed * (percentage_igv / 100), 2)

                    // //impuestos (isc + igv + icbper)
                    // this.form.total_taxes = _.round(this.form.total_igv + this.form.total_isc + this.form.total_plastic_bag_taxes, 2);
                    // this.form.total = _.round(this.form.total_taxed + this.form.total_taxes, 2)
                    // this.form.subtotal = this.form.total

                    // this.form.subtotal = _.round(this.form.total - amount, 2)
                    // this.form.total = _.round(this.form.total - amount_, 2)

                    // if (total_percentage_products > 0) {
                    //     if (this.form.total_unaffected > 0) {
                    //         this.form.total_unaffected = _.round(this.form.total_unaffected - amount, 2)
                    //     } else if (this.form.total_exportation > 0) {
                    //         // this.form.total_exportation = _.round(this.form.total_exportation - amount, 2)
                    //         base = this.form.total_exportation // recupero el total exportacion antes de recaluclas con el cargo
                    //         // this.form.total_exportation = _.round(this.form.total / (1 + (total_percentage_products / 100)), 2)
                            
                    //     } else if (this.form.total_exonerated > 0) {
                    //         this.form.total_exonerated = _.round(this.form.total_exonerated - amount, 2)
                            
                    //     }
                    // }

                    const new_total = _.round(this.form.total - amount, 2)

                    if (new_total <= 0) {
                        this.$message.error("El total debe ser mayor a 0, verifique el monto de descuento ingresado")
                        return
                    }

                    this.form.subtotal = this.form.total
                    this.form.total = new_total

                }
                // descuentos que no afectan la bi
                else
                {
                    this.form.total = _.round(this.form.total - amount, 2)
                }
                this.global_discount_non_taxed = _.round(amount, 2)
                this.setGlobalDiscount(factor, _.round(amount, 2), base.toFixed(2), '03')

            } else {

                const percentage_igv = this.percentage_igv * 100 // resulta 18 ó 10
                //input donde se ingresa monto o porcentaje
                let input_global_discount = parseFloat(this.total_global_discount)

                // obtener el porcenteaje cargo productos
                // console.log('items')
                // console.log(this.form.items)
                const total_percentage_products = this.form.items.reduce((total, row) => {
                    const tip_percentage = parseFloat(row.item.tip_percentage)
                    return total + (row.item.tip_percentage && !isNaN(tip_percentage) ? tip_percentage : 0)
                }, 0)
                // console.log('total_percentage_products')
                // console.log(total_percentage_products)

                if (this.is_amount && this.isGlobalDiscountBase) {
                    // let aux_percentage = percentage_igv === 18 ? 1.18 : 1.10
                    let aux_percentage = 1 + this.percentage_igv
                    input_global_discount = parseFloat(input_global_discount / (aux_percentage + (total_percentage_products / 100))).toFixed(5)
                }
                // console.log('percentage_igv')
                // console.log(percentage_igv)
                // console.log('input_global_discount')
                // console.log(input_global_discount)

                if (input_global_discount > 0)
                {
                    // const percentage_igv = 18
                    let base = (this.isGlobalDiscountBase) ? parseFloat(this.form.total_taxed_without_rounding) : parseFloat(this.form.total)
                    let amount = 0
                    let factor = 0

                    if (this.is_amount)
                    {
                        amount = input_global_discount
                        factor = _.round(amount / base, 5)
                    }
                    else
                    {
                        factor = _.round(input_global_discount / 100, 5)
                        amount = factor * base
                    }

                    //this.form.total_discount = _.round(amount, 5)
                    const globalDiscountAmount = _.round(amount, 5)
                    this.form.total_discount = _.round(this.getItemsTotalDiscount() + globalDiscountAmount, 5)
                    // descuentos que afectan la bi
                    if(this.isGlobalDiscountBase)
                    {
                        
                        this.form.total_taxed = _.round(base - globalDiscountAmount, 2)
                        this.form.total_value = this.form.total_taxed
                        this.form.total_igv = _.round(this.form.total_taxed * (percentage_igv / 100), 2)

                        //impuestos (isc + igv + icbper)
                        // recalcular monto de cargo productos
                        const new_total_charge_46 = _.round(this.form.total_taxed * (total_percentage_products / 100), 2)

                        this.form.total_taxes = _.round(this.form.total_igv + this.form.total_isc + this.form.total_plastic_bag_taxes, 2);
                        this.form.total = _.round(this.form.total_taxed + this.form.total_taxes + new_total_charge_46 + parseFloat(this.form.rounding || 0), 2)
                        this.form.subtotal = this.form.total

                        if (this.form.total <= 0) {
                            this.$message.error("El total debe ser mayor a 0, verifique el tipo de descuento asignado (Configuración/Avanzado/Contable)")
                            // return
                        }

                    }
                    // descuentos que no afectan la bi
                    else
                    {
                        this.form.total = _.round(this.form.total - amount, 2)
                    }

                    this.setGlobalDiscount(factor, _.round(amount, 2), base.toFixed(2))

                }


            }



        },
        async deleteInitGuides() {
            await _.remove(this.form.guides, {'number': null})
        },
        async asignPlateNumberToItems() {

            if (this.form.plate_number) {

                await this.form.items.forEach(item => {

                    let at = _.find(item.attributes, {'attribute_type_id': '5010'})

                    if (!at) {
                        item.attributes.push({
                            attribute_type_id: '5010',
                            description: "Numero de Placa",
                            value: this.form.plate_number,
                            start_date: null,
                            end_date: null,
                            duration: null,
                        })
                    } else {

                        // if (this.isUpdate) {
                            at.value = this.form.plate_number
                        // }
                    }

                });

            }
        },
        async validateAffectationTypePrepayment() {

            let not_equal_affectation_type = 0

            await this.form.items.forEach(item => {
                if (item.affectation_igv_type_id != this.form.affectation_type_prepayment) {
                    not_equal_affectation_type++
                }
            });

            return {
                success: (not_equal_affectation_type > 0) ? false : true,
                message: 'Los items deben tener tipo de afectación igual al seleccionado en el anticipo'
            }
        },
        validatePaymentDestination() {

            let error_by_item = 0

            this.form.payments.forEach((item) => {

                if (!['05', '08', '09'].includes(item.payment_method_type_id)) {
                    if (item.payment_destination_id == null) error_by_item++;
                }

            })

            return {
                error_by_item: error_by_item,
            }

        },
        async submit() {

            // validacion monto > 700
            if (this.exceeds700) {
                this.$message({
                    message: 'El monto de la venta supera los S/. 700, es necesario identificar al cliente con su DNI o RUC.',
                    type: 'warning'
                })
                return
            }

            // validando si es exportacion servicios

            const guests = this.form.hotel.guests ? JSON.parse(this.form.hotel.guests) : []
            if (this.form.operation_type_id == '0202' && (Object.keys(this.form.hotel).length === 0 || guests.length === 0)) {
                return this.$message.error('Debe ingresar datos del huésped');
            }

            if (this.form.operation_type_id === '0208' && !this.form.service_country_id) {
                return this.$message.error('Debe seleccionar el país de uso, explotación o aprovechamiento del servicio')
            }

            //Validando las series seleccionadas
            let errorSeries = false;
            _.forEach(this.form.items, row => {
                if(row.item.series_enabled) {
                    errorSeries = parseFloat(row.quantity) !== row.item.lots.length
                    return false;
                }
            });
            if(errorSeries) {
                this.$message.error('No se han seleccionado todas las series');
                return false;
            }

            // if (this.form.show_terms_condition) {
            //     this.form.terms_condition = this.config.terms_condition_sale;
            // }

            // TODO: ACA SE VALIDA SI VA O NO TERMINOS Y CONDICIONES EN LA FACTURA/BOLETA
            // if (this.configuration.show_terms_condition_sale) this.form.terms_condition = this.config.terms_condition_sale;
            if (this.show_terms_and_conditions) this.form.terms_condition = this.config.terms_condition_sale

            if (this.form.has_prepayment || this.prepayment_deduction) {
                let error_prepayment = await this.validateAffectationTypePrepayment()
                if (!error_prepayment.success)
                    return this.$message.error(error_prepayment.message);
            }


            if (this.is_receivable) {
                this.form.payments = []
            } else {
                let validate = await this.validate_payments()
                if (validate.acum_total > parseFloat(this.form.total) || validate.error_by_item > 0) {
                    return this.$message.error('Los montos ingresados superan al monto a pagar o son incorrectos');
                }

                let validate_payment_destination = await this.validatePaymentDestination()

                if (validate_payment_destination.error_by_item > 0) {
                    //return this.$message.error('El destino del pago es obligatorio');

                    return this.$message({
                    dangerouslyUseHTMLString: true,
                    type: 'error',
                    message: `El destino de pago es obligatorio. Caja chica se encuentra cerrada. <a style="color: #409EFF" href="/cash" target="_blank">Ir a caja chica</a>`
                    })
                }

            }

            await this.deleteInitGuides()
            await this.asignPlateNumberToItems()

            let val_detraction = await this.validateDetraction()
            if (!val_detraction.success)
                return this.$message.error(val_detraction.message);

            if (!this.enabled_payments) {
                this.form.payments = []
            }

            // validacion sistema por puntos
            if(this.config.enabled_point_system)
            {
                const validate_exchange_points = this.validateExchangePoints()
                if(!validate_exchange_points.success) return this.$message.error(validate_exchange_points.message)
            }
            // validacion sistema por puntos

            if(this.isGeneratedFromExternal)
            {
                // validacion restriccion de productos
                const validate_restrict_sale_items_cpe = this.fnValidateRestrictSaleItemsCpe(this.form)
                if(!validate_restrict_sale_items_cpe.success) return this.$message.error(validate_restrict_sale_items_cpe.message)
            }

            this.loading_submit = true
            let path = `/${this.resource}`;
            if (this.isUpdate) {
                path = `/${this.resource}/${this.form.id}/update`;
            }
            let temp = this.form.payment_condition_id;
            // Condicion de pago Credito con cuota pasa a credito
            if (this.form.payment_condition_id === '03') this.form.payment_condition_id = '02';
            
            this.form.dcto_monto_input = this.total_global_discount
            // this.form.dcto_totales_input = 0 // asignado en totalDiscountOnlyVisual()
            this.form.monto_pagar_sin_dcto = this.monto_pagar_sin_dcto
            this.form.has_sale_note = this.has_sale_note
            
            this.$http.post(path, this.form).then(response => {

                if (response.data.success) {
                    this.$eventHub.$emit('reloadDataItems', null)

                    let flag_cash = true
                    if (this.form.sale_note_id || this.has_sale_note) {
                        if (this.form.sale_note_id) {
                            this.$http.get(`/sale-notes/changed/${this.form.sale_note_id}`).then(() => {})
                        }
                        flag_cash = false
                    }
                    //

                    this.resetForm();
                    this.documentNewId = response.data.data.id;

                    this.showOptionsDialog(response)

                    this.form_cash_document.document_id = response.data.data.id;

                    this.form_cash_document.cash_id = response.data.data.cash_id

                    // this.savePaymentMethod();
                    // if (flag_cash) {
                    //     this.saveCashDocument();
                    // }

                    this.autoPrintDocument()

                    if (this.configuration.download_invoice_pdf) {
                        window.open(`/downloads/document/pdf/${response.data.data.external_id}/a4`, '_blank')
                    }

                } else {
                    // this.$message.error(response.data.message);

                    this.$message({
                        dangerouslyUseHTMLString: true,
                        type: 'error',
                        message: response.data.message
                    })
                }

                if (this.$refs.formRef) this.$refs.formRef.resetGuest()
            }).catch(error => {
                // error de JavaScript dentro del .then (no es un error HTTP): la emisión ya se procesó
                if (!error.response && !error.request) {
                    console.error(error)
                    return
                }

                const status = error.response ? error.response.status : null

                if (status === 422) {
                    this.errors = error.response.data;
                } else if (!status || status === 502 || status === 503 || status === 504) {
                    // sin respuesta del servidor: el comprobante pudo haberse registrado
                    this.$message({
                        type: 'warning',
                        duration: 0,
                        showClose: true,
                        message: 'No se recibió respuesta del servidor. El comprobante pudo haberse registrado: revise el listado de comprobantes antes de volver a emitirlo.'
                    })
                } else if (status === 501) {
                    this.$message({
                        message: error.response.data.message,
                        type: 'warning'
                    })
                } else {
                    this.$message.error(error.response.data.message);
                }
                if (temp === '03') this.form.payment_condition_id = '03';
            }).finally(() => {
                this.loading_submit = false;
                this.setDefaultDocumentType();
            });

        },
        showOptionsDialog(response) {

            if (this.hidePreviewPdf) {
                const response_data = response.data.data

                if (response_data.response.sent) {
                    this.$message.success(response_data.response.description)
                } else {
                    this.$message.success(`Comprobante registrado: ${response_data.number_full}`)
                }
            } else {
                this.showDialogOptions = true
            }

        },
        autoPrintDocument() {

            if (this.isAutoPrint) {
                this.$http.get(`/printticket/document/${this.documentNewId}/ticket`)
                    .then(response => {
                        this.printTicket(response.data)
                    })
                    .catch(error => {
                        console.log(error)
                    })
            }

        },
        printTicket(html_pdf) {

            if (html_pdf.length > 0) {
                const config = getUpdatedConfig()
                const opts = getUpdatedConfig()

                const printData = [
                    {
                        type: 'html',
                        format: 'plain',
                        data: html_pdf,
                        options: opts
                    }
                ]

                qz.print(config, printData)
                    .then(() => {

                        this.$notify({
                            title: '',
                            message: 'Impresión en proceso...',
                            type: 'success'
                        })

                    })
                    .catch(displayError)
            }

        },
        saveCashDocument() {
            this.$http.post(`/cash/cash_document`, this.form_cash_document)
                .then(response => {
                    if (!response.data.success) {
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error => console.log(error))
        },
        validate_payments() {

            //eliminando items de pagos
            for (let index = 0; index < this.form.payments.length; index++) {
                if (parseFloat(this.form.payments[index].payment) === 0)
                    this.form.payments.splice(index, 1)
            }

            let error_by_item = 0
            let acum_total = 0

            this.form.payments.forEach((item) => {
                acum_total += parseFloat(item.payment)
                if (item.payment <= 0 || item.payment == null) error_by_item++;
            })

            return {
                error_by_item: error_by_item,
                acum_total: _.round(acum_total, 2) // acum_total
            }

        },
        close() {
            if (this.table) {
                location.href = `/${this.table}`
            } else {
                location.href = (this.is_contingency) ? `/contingencies` : `/${this.resource}`
            }
        },
        async reloadDataCustomers(customer_id) {
            await this.$http.get(`/${this.resource}/search/customer/${customer_id}`).then((response) => {
                this.customers = response.data.customers
                this.form.customer_id = customer_id
                this.changeCustomer()

                this.setCustomerAccumulatedPoints(customer_id, this.config.enabled_point_system)

            })
        },
        changeCustomer() {
            this.customer_addresses = [];
            this.form.customer_address_id = null;

            let customer = _.find(this.customers, {'id': this.form.customer_id});
            this.customer_addresses = customer.addresses;
            // if (customer.address) {
            //     this.customer_addresses.unshift({
            //         id: null,
            //         address: customer.address
            //     })
            // }

            const main_address = this.customer_addresses.filter(address => address.main)
            this.form.customer_address_id =  main_address.length ? main_address[0].id : null

            this.setCustomerAccumulatedPoints(customer.id, this.config.enabled_point_system)

            let seller = this.sellers.find(element => element.id == customer.seller_id)
            if (seller !== undefined) {
                this.form.seller_id = seller.id

            }

            // retencion para clientes con ruc
            this.validateCustomerRetention(customer.identity_document_type_id)

            /*if(this.customer_addresses.length > 0) {
                let address = _.find(this.customer_addresses, {'main' : 1});
                this.form.customer_address_id = address.id;
            }*/
        },
        validateCustomerRetention(identity_document_type_id) {

            if (identity_document_type_id != '6') {

                if (this.form.has_retention) {
                    this.form.has_retention = false
                    this.changeRetention()
                }

                this.show_has_retention = false

            } else {
                this.show_has_retention = true
            }

        },
        initDataPaymentCondition01() {

            this.readonly_date_of_due = false
            this.enabled_payments = true
            this.form.date_of_due = this.form.date_of_issue
            this.form.payment_method_type_id = null

        },
        changePaymentCondition() {
            this.total_pending_payment_edited = false
            this.form.fee = [];
            this.form.payments = [];
            if (this.form.payment_condition_id === '01') {

                this.clickAddPayment();
                this.initDataPaymentCondition01()
            }
            if (this.form.payment_condition_id === '02') {
                this.clickAddFeeNew();
                this.readonly_date_of_due = true
            }
            if (this.form.payment_condition_id === '03') {
                this.clickAddFee();
            }

            // if(this.isCreditPaymentCondition){
            // this.changeRetention()
            // }

            if (!_.isEmpty(this.form.retention)) {
                this.setTotalPendingAmountRetention(this.form.retention.amount)
            }


        },
        changeCreditFeeDate(index)
        {
            const last_index = this.getLastIndexFee()

            if(last_index === index)
            {
                this.setDateOfDue(this.getLastDateFee(last_index))
            }
        },
        getLastIndexFee()
        {
            return this.form.fee.length - 1
        },
        getLastDateFee(input_last_index = null)
        {
            const last_index = input_last_index || this.getLastIndexFee()

            return this.form.fee[last_index].date
        },
        setDateOfDue(date_of_due)
        {
            this.form.date_of_due = date_of_due
        },
        clickAddFee() {
            this.form.date_of_due = moment().format('YYYY-MM-DD');
            this.form.fee.push({
                id: null,
                date: moment(this.form.date_of_issue, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD'),
                currency_type_id: this.form.currency_type_id,
                amount: 0,
            });
            this.calculateFee();
        },
        clickAddFeeNew() {
            let first = {
                id: '05',
                number_days: 0,
            };
            if (this.credit_payment_metod[0] !== undefined) {
                first = this.credit_payment_metod[0];
            }

            // let date = moment()
            //     .add(first.number_days, 'days')
            //     .format('YYYY-MM-DD')

            let date = moment(this.form.date_of_issue).add(first.number_days, 'days').format('YYYY-MM-DD')

            this.form.date_of_due = date;
            this.form.fee.push({
                id: null,
                document_id: null,
                payment_method_type_id: first.id,
                // reference: null,
                // payment_destination_id: this.getPaymentDestinationId(),
                // payment: 0,

                date: date,
                currency_type_id: this.form.currency_type_id,
                amount: 0,
            });
            this.calculateFee();
        },
        clickRemoveFee(index) {
            this.form.fee.splice(index, 1);
            this.calculateFee();
            this.setDateOfDue(this.getLastDateFee())
        },
        calculatePayments() {
            let payment_count = this.form.payments.length;
            // let total = this.form.total;
            let total = parseFloat(this.getTotal())
            
            let payment = 0;
            let amount = _.round(total / payment_count, 2);
            // console.log(amount);
            _.forEach(this.form.payments, (row, index) => {
                payment += amount;
                // if (total - payment < 0) {
                //     amount = _.round(total - payment + amount, 2);
                // }
                
                // Ajustar el último pago para evitar diferencias por redondeo
                if (index === payment_count - 1) {
                    amount = _.round(total - (payment - amount), 2)
                }

                row.payment = amount;
                // console.error(row.payment)
            })
        },
        calculateFee() {
            let fee_count = this.form.fee.length;
            // let total = this.form.total;
            let total = this.getTotal()

            let accumulated = 0;
            let amount = _.round(total / fee_count, 2);
            _.forEach(this.form.fee, row => {
                accumulated += amount;
                if (total - accumulated < 0) {
                    amount = _.round(total - accumulated + amount, 2);
                }
                row.amount = amount;
            })
        },
        getTotal() {
            let total_pay = this.form.total;
            if(this.form.has_retention) {
                total_pay -= this.form.retention.amount;
            }
            // console.log(this.form.retention)
            // console.log(this.form.total_pending_payment)
            // console.log(this.form.total)

            const has_base = !_.isEmpty(this.form.detraction) || !_.isEmpty(this.form.retention)



            if (has_base && (this.form.total_pending_payment > 0 || this.total_pending_payment_edited)) {
                return parseFloat(this.form.total_pending_payment) || 0
            }

            // console.log('2');
            return total_pay
        },
        setDescriptionOfItem(item) {
            return showNamePdfOfDescription(item, this.config.show_pdf_name)
        },
        checkKeyWithAlt(e) {
            let code = e.event.code;
            if (
                this.showDialogOptions === true &&
                code === 'KeyN'
            ) {
                this.showDialogOptions = false
            }

            if (
                code === 'KeyG'  // key G
                && !this.showDialogAddItem   // Modal hidden
                && this.form.items.length > 0  // with items
                && this.focus_on_client === false // not client search
            ) {
                this.submit()
            }
        },
        checkKey(e) {
            let code = e.event.code;
            if (code === 'F2') {
                //abrir el modal de agergar producto
                if (!this.showDialogAddItem) this.showDialogAddItem = true
            }
            if (code === 'Escape') {
                if (this.showDialogAddItem) this.showDialogAddItem = false
            }
        },
        openDialogLots(item) {
            console.log(item);
            this.recordItem = item;
            this.showDialogItemSeriesIndex = true;
        },
        successItemSeries(series) {
            let itemIndex = _.findIndex(this.form.items, {'item_id': this.recordItem.item_id});
            this.form.items[itemIndex].item.lots = series;
        },
        showItemSeries(series) {
            return series.map(o => o['series']).join(', ');
        },
        handleEnterKey(event) {
            event.preventDefault();
            event.target.blur();
        },
        async openDialogPreview(){
            let validate  = await this.validatePreview()
            if(!validate){
                return;
            }
            this.showDialogPreview = true;
        },
        async validatePreview(){
            let errorSeries = false;
            _.forEach(this.form.items, row => {
                if(row.item.series_enabled) {
                    errorSeries = parseFloat(row.quantity) !== row.item.lots.length
                    return false;
                }
            });
            if(errorSeries) {
                this.$message.error('No se han seleccionado todas las series');
                return false;
            }

            if(!this.form.customer_id){
                this.$message.error('Debe seleccionar cliente');
                return false;
            }

            // if (this.form.show_terms_condition) {
            if (this.show_terms_and_conditions) {
                this.form.terms_condition = this.config.terms_condition_sale;
            }
            if (this.form.has_prepayment || this.prepayment_deduction) {
                let error_prepayment = await this.validateAffectationTypePrepayment()
                if (!error_prepayment.success){
                    this.$message.error(error_prepayment.message)
                    return false;
                }

            }

            if (this.is_receivable) {
                this.form.payments = []
            } else {
                let validate = await this.validate_payments()
                if (validate.acum_total > parseFloat(this.form.total) || validate.error_by_item > 0) {
                    this.$message.error('Los montos ingresados superan al monto a pagar o son incorrectos');
                    return false;
                }

                let validate_payment_destination = await this.validatePaymentDestination()

                if (validate_payment_destination.error_by_item > 0) {
                    this.$message.error('El destino del pago es obligatorio')
                    return false;

                }
            }

            await this.deleteInitGuides()
            await this.asignPlateNumberToItems()

            let val_detraction = await this.validateDetraction()
            if (!val_detraction.success){
                this.$message.error(val_detraction.message);
                return false;
            }

            if (!this.enabled_payments) {
                this.form.payments = []
            }

            if(this.config.enabled_point_system)
            {
                const validate_exchange_points = this.validateExchangePoints()
                if(!validate_exchange_points.success){
                    this.$message.error(validate_exchange_points.message)
                    return false;
                }
            }

            return true;

        },
        async preview(format) {

            this.loading_submit = true
            let path = `/${this.resource}/preview`;

            let temp = this.form.payment_condition_id;

            if (this.form.payment_condition_id === '03') this.form.payment_condition_id = '02';

            let url = null;
            let original_format_pdf = this.form.actions.format_pdf;
            this.form.actions.format_pdf = format;
            let sendData = this.form
            sendData.monto_pagar_sin_dcto = this.monto_pagar_sin_dcto
            if (this.documentId) {
                sendData.number = "#"
            }
            try {
                let response = await this.$http.post(path, sendData, {
                    responseType: 'blob'
                });
                const blob = new Blob([response.data], { type: "application/pdf" });
                url = URL.createObjectURL(blob);
                if (temp === '03') this.form.payment_condition_id = '03';
            }
            catch (error) {
                console.log('error', error);
                if (temp === '03') this.form.payment_condition_id = '03';
            }
            finally {
                this.loading_submit = false;
                this.form.actions.format_pdf = original_format_pdf;
            }

            return url;
        },

        recalculateTotalForPayment(index) {
            if (!this.auto_calculate_amount) {
                return
            }
            const total_pay = this.getTotal()
            const current_payment_obj = this.form.payments[index]
            const current_payment = parseFloat(current_payment_obj.payment || 0)
            const diference = total_pay - current_payment

            if (diference > 0) {
                const more_payment_count = this.form.payments.length - 1
                if (more_payment_count > 0) {
                    let payment = 0
                    let amount = _.round(diference / more_payment_count, 2)
                    const others_payments_add = this.form.payments.filter((_, i) => i !== index)
                    others_payments_add.forEach((row, _index) => {
                        payment += amount
                        // ajustar ultimo pago para evitar diferencias por redondeo
                        if (_index === more_payment_count - 1) {
                            amount = _.round(diference - (payment - amount), 2)
                        }
                        row.payment = amount
                    })
                }
            }
            
        },
        setMixedGlobalDiscount(inputDiscount, taxedBase, nonTaxedBase) {
            const round2 = value => _.round(value, 2)

            const originalValue = Number(this.form.total_value) || 0
            const originalIgv = Number(this.form.total_igv) || 0
            const originalTaxes = Number(this.form.total_taxes) || 0
            const originalSubtotal = Number(this.form.subtotal) || 0
            const originalTotal = Number(this.form.total) || 0

            // Importe gravado incluido el impuesto.
            const taxedGross = round2(taxedBase + originalIgv)
            const eligibleGross = round2(taxedGross + nonTaxedBase)

            const factorRaw = this.is_amount
                ? inputDiscount / eligibleGross
                : inputDiscount / 100

            if (factorRaw <= 0 || factorRaw >= 1) {
                this.$message.error('El descuento debe ser menor al total elegible')
                return
            }

            const targetDiscount = this.is_amount
                ? round2(inputDiscount)
                : round2(eligibleGross * factorRaw)

            const itemDiscounts = round2(
                this.form.items.reduce(
                    (sum, row) => sum + (Number(row.total_discount) || 0),
                    0
                )
            )

            if (this.configuration.global_discount_type_id === '02') {
                const taxedDiscount = round2(taxedBase * factorRaw)
                const newTaxedBase = round2(taxedBase - taxedDiscount)
                const newIgv = round2(originalIgv * (1 - factorRaw))

                const newTaxes = round2(
                    originalTaxes - originalIgv + newIgv
                )

                // Reducción económica: descuento de base + reducción del impuesto.
                const taxedGrossReduction = round2(
                    taxedDiscount + originalIgv - newIgv
                )

                // Se asigna aquí cualquier residuo de centavos, acotado a [0, base no gravada].
                const nonTaxedTarget = round2(targetDiscount - taxedGrossReduction)
                const nonTaxedDiscount = Math.max(
                    0,
                    Math.min(nonTaxedTarget, round2(nonTaxedBase))
                )

                // Diferencia que no cupo en la porción no gravada.
                const residual = round2(nonTaxedTarget - nonTaxedDiscount)

                if (Math.abs(residual) > 0.01) {
                    this.$message.warning(
                        `El descuento aplicado es ${round2(targetDiscount - residual)} por ajuste de redondeo`
                    )
                }


                this.form.total_taxed = newTaxedBase
                this.form.total_igv = newIgv
                this.form.total_taxes = newTaxes
                this.form.total_value = round2(originalValue - taxedDiscount)
                this.form.subtotal = round2(
                    originalSubtotal - taxedGrossReduction
                )
                this.form.total = round2(
                    originalTotal - taxedGrossReduction - nonTaxedDiscount
                )

                this.form.total_discount = round2(
                    itemDiscounts + taxedDiscount + nonTaxedDiscount
                )

                if (taxedDiscount > 0) {
                    this.setGlobalDiscount(
                        _.round(taxedDiscount / taxedBase, 5),
                        taxedDiscount,
                        round2(taxedBase).toFixed(2),
                        '02'
                    )
                }

                if (nonTaxedDiscount > 0) {
                    this.global_discount_non_taxed = nonTaxedDiscount  
                    this.setGlobalDiscount(
                        _.round(nonTaxedDiscount / nonTaxedBase, 5),
                        nonTaxedDiscount,
                        round2(nonTaxedBase).toFixed(2),'03'
                    )
                }


                return
            }

                        // Configuración 03: no modifica base ni impuesto.
            const taxedDiscount = round2(taxedGross * factorRaw)
            const nonTaxedTarget = round2(targetDiscount - taxedDiscount)
            const nonTaxedDiscount = Math.max(
                0,
                Math.min(nonTaxedTarget, round2(nonTaxedBase))
            )

            this.form.subtotal = originalSubtotal
            this.form.total = round2(
                originalTotal - taxedDiscount - nonTaxedDiscount
            )
            this.form.total_discount = round2(
                itemDiscounts + taxedDiscount + nonTaxedDiscount
            )

            if (taxedDiscount > 0) {
                this.setGlobalDiscount(
                    _.round(taxedDiscount / taxedGross, 5),
                    taxedDiscount,
                    taxedGross.toFixed(2),
                    '03'
                )
            }

            if (nonTaxedDiscount > 0) {
                this.global_discount_non_taxed = nonTaxedDiscount
                this.setGlobalDiscount(
                    _.round(nonTaxedDiscount / nonTaxedBase, 5),
                    nonTaxedDiscount,
                    nonTaxedBase.toFixed(2),'03'
                )
            }

        },
        getItemsTotalDiscount() {
            return _.round(
                this.form.items.reduce(
                    (sum, row) => sum + (Number(row.total_discount) || 0),
                    0
                ),
                2
            )
        },
        normalizeDiscountTypeId(value) {
            return String(value ? value : '').trim().padStart(2, '0')
        },
        changeTotalPendingPayment(value) {
            let amount = parseFloat(value)
            if (isNaN(amount) || amount < 0) amount = 0

            const max = this.max_total_pending_payment
            if (max > 0 && amount > max) amount = max

            this.form.total_pending_payment = _.round(amount, 2)
            this.total_pending_payment_edited = true

            // deja un único método de pago con el M. PENDIENTE; no toca totales, IGV, detracción ni retención
            this.setSinglePaymentForPendingPayment()
        },

        checkTotalPendingPayment() {
            const value = this.form.total_pending_payment
            if (value === '' || value === null || value === undefined) {
                this.form.total_pending_payment = 0
                this.total_pending_payment_edited = true
                this.calculateAmountToPayments()
            }
        },
        setSinglePaymentForPendingPayment() {
            const amount = _.round(parseFloat(this.getTotal()) || 0, 2)

            // Contado: un solo método de pago con el M. PENDIENTE
            if (this.form.payment_condition_id === '01') {

                if (this.form.payments.length === 0) {
                    this.clickAddPayment()
                } else if (this.form.payments.length > 1) {
                    this.form.payments.splice(1)   // conserva la primera fila (método, destino, referencia, voucher)
                }

                this.form.payments[0].payment = amount
                return
            }

            // Crédito / crédito con cuotas: una sola cuota con el M. PENDIENTE
            if (this.form.fee.length === 0) {
                (this.form.payment_condition_id === '02') ? this.clickAddFeeNew() : this.clickAddFee()
            } else if (this.form.fee.length > 1) {
                this.form.fee.splice(1)
            }

            this.form.fee[0].amount = amount
            this.setDateOfDue(this.getLastDateFee())
        },
    }
}
</script>


// WEBPACK FOOTER //
// resources/js/views/tenant/documents/invoice_generate.vue